import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Inject, Injectable, Optional } from '@angular/core';
import { LogService } from '@pershing/pershing-core';
import { Account, PdfPacket, TaxLot, TaxLotDetail, TradingEntitlements, TradingOrderBase, TransactionType, UserType } from "../../models";
import { GetUserType, getValueOrEmptyString } from "../../utils/trading-common";
import { EquityTradingUtils } from "../equity/equity-trading-utils-service.service";
import { MutualFundTradingUtils } from "../mutualfund/mutualfund-trading-utils-service.service";
import { OptionTradingUtils } from "../option/option-trading-utils-service.service";
import { TradingDataService } from "./trading-data-service.service";
import { TAXLOT_DISPOSITION_METHOD_LIST } from "../../utils/trading-constants";
import { DecimalPipe, registerLocaleData } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import es from "@angular/common/locales/es";
import { Subscription } from 'rxjs';
import { TradingService } from "./trading-service.service";


export class printOrder {
            accountName: string;
            ip: string;
            accountAdress: string;
            orderDescription: string;
            orderTitleStyle: string;
            quoteDescription: string;
            ordQty: string;
            orderType: string;
            stopPrice: string;
            limitPrice: string;
            trailDollarQty: string;
            trailPctQty: string;
            limitOffset: string;
            trailingBasedOn:string;
            settlementCcy: string;
            docLocation:string;
            chgPct: string;
            duration: string;
            gtdDate: string;
            accountType: string;
            solicited: string;
            floorInst: string;
            trailer: string;
            discExercised: string;


        }
const disclaimer = 'This report is a service from your Investment Professional, not a substitute for your account statements and confirmations. This report is prepared as of trade date rather than settlement date and may be prepared on a different date than your statement. This report uses information from sources that Pershing believes to be reliable, but Pershing cannot guarantee the accuracy of this information on the reliability of these sources. If you find discrepancies in this report, please contact your Investment Professional.'
const commaDelimiterRE: RegExp = /\B(?=(\d{3})+(?!\d))/g;
@Injectable()
export class PrintpdfService {
  name = 'Angular ';

  decimalPipe: DecimalPipe = new DecimalPipe('en-US'); 
  showCatEntity:boolean = false;
  isExtended: boolean = false;
  isComplex: boolean = false;
  isDualUser: boolean = false;
  isMultiPositionRedeemOrExchange:boolean = false;
  isOrdQty: boolean;
  isShareQty: boolean;
  isDollarQty: boolean;
  availQty: number;
  totalLots: number;
  totalSelQty: number;
  showTaxlotsGrid: boolean;
  isTaxlotsConfirmed:boolean;
  orderSubmittedSuccessfully:boolean;
  taxLot:TaxLot;
  dispMethodCode: string;
  dispMethodStr: string = '';
  taxLotGridData: any[];
  taxLotBody: any[];
  taxLotGrid: any[];
  orderlegalEntity: any;
  origOrderlegalEntity: any;
  legalEntitySub: Subscription;
  isNonDollar: boolean = false;
  tradeType:string;
  currencyCode:string;

  constructor(private logService: LogService, @Optional() @Inject('AppSettings') appSettings: any, private translateService: TranslateService, private tradingService?:TradingService,private tradingDataService?:TradingDataService, private equityTradingUtils?: EquityTradingUtils, private mutualFundTradingUtils?: MutualFundTradingUtils, private optionTradingUtils?: OptionTradingUtils) {
    pdfMake.vfs = !!pdfFonts.pdfMake?.vfs ? pdfFonts.pdfMake.vfs : window['pdfMake']['vfs'];
    if (appSettings?.language === 'es') {
      registerLocaleData( es );
    }
  }

  public generatePDF(packet:PdfPacket,orderSubmittedSuccessfully:boolean) {
    let entitlementsCopy = JSON.parse(JSON.stringify(packet.entitlements));
    const currUserType: UserType = GetUserType(packet.account, entitlementsCopy);

    entitlementsCopy.isRiaUser = UserType.RIA === currUserType;
    entitlementsCopy.isBdUser = UserType.BD === currUserType;
    this.isDualUser = UserType.DUAL === currUserType;
    
    let packetCopy = JSON.parse(JSON.stringify(packet));
    packetCopy.entitlements = entitlementsCopy;
    this.isComplex = (!!packetCopy.entitlements.isEntitledToComplexOption && packetCopy.order.tradeType==='OPTION');
    if (this.isComplex) {
      this.optionTradingUtils.hasQuantityEdited = false;
      this.optionTradingUtils.setComplexGlobals(packetCopy.order,packetCopy.account,packetCopy.entitlements,packetCopy.origOrder)
    }
    this.orderSubmittedSuccessfully = orderSubmittedSuccessfully;
    this.isNonDollar = this.nonDollar(packetCopy.order);
    this.tradeType = packetCopy.order.tradeType;
    
    if (['OPTION','EQUITY','MUTUAL_FUND'].includes(packetCopy.order.tradeType)) {
      this.taxLotBody = this.createTaxLotTableGridHybrid(packetCopy.order,packetCopy.entitlements);
    }
    let printOrder = this.getPrintOrder(packetCopy);
    let printOrigOrder;
    if (!!packet.origOrder) {
      let packetCopyOrigOrder = JSON.parse(JSON.stringify(packet));
      packetCopyOrigOrder.entitlements = entitlementsCopy;
      packetCopyOrigOrder.order = packetCopyOrigOrder.origOrder;
      printOrigOrder = this.getPrintOrder(packetCopyOrigOrder);
    }
    this.showCatEntity = false;
    this.handleFDID(packetCopy.order,packetCopy.origOrder,packetCopy.account,entitlementsCopy)
    this.isExtended = !!packet.isExtended;
    this.isMultiPositionRedeemOrExchange = !!packet.isMultiPositionRedeemOrExchange;
    
    console.log(pdfMake);

    const documentDefinition = this.getDocumentDefinition(printOrder,printOrigOrder,entitlementsCopy,packet.origOrder);
    pdfMake.createPdf(documentDefinition).open();
    if (!!this.legalEntitySub) {
      this.orderlegalEntity = undefined;
      this.origOrderlegalEntity = undefined;
      this.legalEntitySub.unsubscribe();
    }
  }

  public clearOutPrevTaxLotInfo() {
    //clearing out the previous taxLot info in accordance with the formatting expected by the pdf doc preprocessor from pdfMake
    //FIXME -- may not be necessary anymore with the latest refactoring to set pdf services tax lot related globals from the review wrappers initialization
    // will investigate further while refactoring/unittesting the code
    this.showTaxlotsGrid = false;
    this.isTaxlotsConfirmed = false;
    this.taxLotGridData = [];


    this.taxLotBody= [[]];
    this.taxLotGrid= [[]];
    this.dispMethodStr='';
    this.taxLot = undefined;
  }

  private nonDollar(order:any) {
    if (order.mutualFund?.offshoreFundInd === 'Y') {
      this.currencyCode = order.mutualFund?.currencyCode !== '' ? order.mutualFund.currencyCode : 'USD';
      return true;
    } else if (order.quote?.qtIntlInd === 'Y') {
      this.currencyCode = order.quote.qtCurrencyCd;
      return true;
    } else {
      this.currencyCode = 'USD';
      return false;
    } 
  }

  handleFDID(order:any,origOrder:any,account:any,entitlements:any){
    //FIXME pull out to common library most likely
    if (this.equityTradingUtils.setShowPDFCatEntity(account,entitlements,order,origOrder,this.showCatEntity)) {
      this.showCatEntity = true;
      this.legalEntitySub = this.tradingService?.orderEntrylegalEntities$.subscribe((data) => {
        for (const iterator of data) {
            if (!!order?.fdid && iterator.FDID === order.fdid?.trim()) {
                this.orderlegalEntity = iterator
            }
            if (!!origOrder?.fdid && iterator.FDID === origOrder.fdid?.trim()) {
                this.origOrderlegalEntity = iterator
            }
        }
    });
    }
  }


  private createTaxLotTableGridHybrid(order:any,entitlements:TradingEntitlements) {
    let body = [];
    let txt = '';
    if (!!this.dispMethodStr) {
      this.translateService.get(this.dispMethodStr).subscribe((translation: string) => {
        txt+= translation;
      });
    }
    body.push([{border: [false, true, false, false],fillColor: '#eeeeee',text: 'Tax Lot Details:', style: 'tableHeader', colSpan: 4}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}]);
    if (!this.showTaxlotsGrid && this.isTaxlotsConfirmed){
      body.push([{text:'Disposition Method:',style:'tabledata1'}, {text:txt, style: 'tabledata', colSpan: 3}]);
    } else if(this.showTaxlotsGrid && this.isTaxlotsConfirmed) {
      this.buildTaxLotBodyGridConfirmed(order,body,entitlements);
      this.taxLotGrid = this.tackTaxLotGrid(order,entitlements)
    } else {
      body = [['','','','']]
    }
    return body;
  }

  private splitRegExPlusNum(value:number) {
    //FIXME -- pull me and my copies in the validators out to a common lib. Also tighten up logic while refactoring unit testing when I get some more breathing room.
    let split:string[]=[];
    if (value === null || value === undefined) {
      return '';
  }
    if (value === 0 || !!value) {
      split = value.toFixed(2).split('.');
    }
    let split0 = ''
    let split1 = '';
    let decimal = '';
    if (!!split[0]) {
      split0 = split[0]
    }
    if (!!split[1]) {
      split1 = split[1];
      decimal = '.';
    }
    return (split0).replace(commaDelimiterRE, ',') + decimal + split1;
  }
  
  private tackTaxLotGrid(order:any,entitlements:TradingEntitlements) {
    let body = [];
    let allowSellFractionalSharesTrading = entitlements.isSellFractionalSharesWithEntitlementEnabled === 'N' ? true : entitlements.isEntitledToFractionalDollar;
    body.push([{text:'Trade Date',colSpan:1,style:'tabledata1'},{text:'Available Qty',colSpan:1,style:'tabledata1'},{text:'Selected Qty',colSpan:1,style:'tabledata1'},{text:'Unit Cost',colSpan:1,style:'tabledata1'}])

    for ( let i: number = 0; i < this.taxLotGridData.length; i++ ) {
      body.push([{text:this.taxLotGridData[i].strPurchaseDate,style:'tabledata',colSpan:1}, {text:this.decimalPipe.transform(this.taxLotGridData[i].availableQty,'1.4-4'),style:'tabledata',colSpan:1},{text:this.decimalPipe.transform(this.taxLotGridData[i].disposeQty,['MUTUAL_FUND'].includes(order.tradeType)||(['EQUITY'].includes(order.tradeType)&& allowSellFractionalSharesTrading)?'1.4-4':'1.0-0'),style:'tabledata',colSpan:1},{text:this.decimalPipe.transform(this.taxLotGridData[i].unitCostAmt,'1.2-4'),style:'tabledata',colSpan:1}]);
    }
    return body;
  }

  private buildTaxLotBodyGridConfirmed(order:any,body:any[],entitlements:TradingEntitlements) {
    body.push([{text:'Total Selected Tax Lots:',style:'tabledata1'}, {text:(this.decimalPipe.transform(this.totalLots,'1.0-3') + ' Versus Purchase'), style: 'tabledata', colSpan: 3}]);
    if (order.tradeType==='OPTION') {
      if (this.totalLots>1) {
        if(this.isShareQty) {
          body.push([{text:'Total Selected Quantity:',style:'tabledata1'}, {text:(this.decimalPipe.transform(order.shareQty,'1.0-0')), style: 'tabledata', colSpan: 3}]);
        } else if(this.isOrdQty) {
          body.push([{text:'Total Selected Quantity:',style:'tabledata1'}, {text:(this.decimalPipe.transform(order.ordQty,'1.0-0')), style: 'tabledata', colSpan: 3}]);
        } else if(this.isDollarQty) {
          body.push([{text:'Total Selected Amount:',style:'tabledata1'}, {text:('$'+this.decimalPipe.transform(order.dollarQty,'1.0-2')), style: 'tabledata', colSpan: 3}]);
        }
      }
    } else if(['EQUITY','MUTUAL_FUND'].includes(order.tradeType)) {
      this.buildTaxLotBodyNonOptions(order,body,entitlements);
    }
  }

  private buildTaxLotBodyNonOptions(order:any,body:any[],entitlements:TradingEntitlements) {
    if (this.totalLots>1) {
      if ((order.tradeType==='EQUITY' && entitlements.isEntitledToFractionalDollar) || (order.tradeType === 'MUTUAL_FUND')) {
        if(this.isShareQty) {
          body.push([{text:'Total Selected Quantity:',style:'tabledata1'}, {text:(this.decimalPipe.transform(order.shareQty,'1.4-4')), style: 'tabledata', colSpan: 3}]);
        } else if (this.totalSelQty) {
          body.push([{text:'Total Selected Quantity:',style:'tabledata1'}, {text:(this.decimalPipe.transform(this.totalSelQty,'1.4-4')), style: 'tabledata', colSpan: 3}]);
        }
      } else if (order.tradeType==='EQUITY' && !entitlements.isEntitledToFractionalDollar) {
        this.equityWholeDollarTaxLot(order,body);
      }
      if(this.isDollarQty) {
        body.push([{text:'Total Selected Amount:',style:'tabledata1'}, {text:('$'+this.decimalPipe.transform(order.dollarQty,'1.2-2')), style: 'tabledata', colSpan: 3}]);
      }
    }
  }

  private equityWholeDollarTaxLot(order:any,body:any[]) {
    if(this.isShareQty) {
      body.push([{text:'Total Selected Quantity:',style:'tabledata1'}, {text:(this.decimalPipe.transform(order.shareQty,'1.0-0')), style: 'tabledata', colSpan: 3}]);
    } else if (this.isOrdQty) {
      body.push([{text:'Total Selected Quantity:',style:'tabledata1'}, {text:(this.decimalPipe.transform(order.orderQty,'1.0-0')), style: 'tabledata', colSpan: 3}]);
    }
  }
  

  public taxLotGlobals(order:any) {
    if (['EQUITY','OPTION'].includes(order.tradeType)) {
      if ([TransactionType.SELL_FROM_PORTFOLIO,TransactionType.BUY_TO_COVER,TransactionType.BUY_CALL_TO_CLOSE,TransactionType.BUY_PUT_TO_CLOSE,TransactionType.CLOSE_EXISTING_CALL,TransactionType.CLOSE_EXISTING_PUT].includes(order.transactionType)) {
        this.taxLot = order.taxLot;
      }
      this.isDollarQty = false;
      this.isShareQty = false;
      this.isOrdQty = true;
    } else if (order.tradeType === 'MUTUAL_FUND') {
      if ([TransactionType.REDEEM,TransactionType.REDEEM_ALL,TransactionType.EXCHANGE,TransactionType.EXCHANGE_ALL].includes(order.transactionType)) {
        this.taxLot = order.taxLot;
      }
      if (!!order.dollarQty) {
        this.isDollarQty = true;
        this.isShareQty = false;
        this.isOrdQty = false;
      } else if (!!order.shareQty) {
        this.isDollarQty = false;
        this.isShareQty = true;
        this.isOrdQty = false;
      }
    }
    if (!!this.taxLot) {
      this.handleTaxLot();
    }
  }

  private handleTaxLot():void {
    if (this.taxLot.errorCode !== 0) {
      this.showTaxlotsGrid = false;
      this.logService.error('taxLotService.getTaxlotDetails response error - ', this.taxLot);
      return;
    }
    this.isTaxlotsConfirmed = true;
    this.availQty = this.tradingDataService.availableQty;
    if (!!this.taxLot.sellMethodCode) {
      this.dispMethodCode = this.taxLot.sellMethodCode.trim().toUpperCase();
    } else if (!!this.tradingDataService.defaultDispositionMethodResp && !!this.tradingDataService.defaultDispositionMethodResp.defaultSellMethodCode) {
      this.dispMethodCode = this.tradingDataService.defaultDispositionMethodResp.defaultSellMethodCode.trim().toUpperCase();
      this.fetchTaxlots();
    }
    if (!!this.dispMethodCode) {
      const method = TAXLOT_DISPOSITION_METHOD_LIST.find(i => i.code === this.dispMethodCode,this);
      if ( !!method ) {
        this.dispMethodStr = method.label || '';
      } else {
        this.dispMethodStr = '';
      }
    }
  }


  private fetchTaxlots() {
    this.showTaxlotsGrid = true;
    if (this.taxLot.returnCode === 0 && !!this.taxLot.taxLotDetails) {
      this.totalLots = this.taxLot.taxLotDetails.length;
      this.getInitRowData(this.taxLot.taxLotDetails);
    }
  }

  getInitRowData(taxLotDetails) {
    let rowList = [];
    this.totalSelQty = 0;
    if (taxLotDetails) {
      taxLotDetails.forEach((taxlot: TaxLotDetail) => {
        const totalDisposeQty = Number(taxlot.disposeQty);
        this.totalSelQty += totalDisposeQty;
        let row: any = taxlot;
        rowList.push(row);
      });
    }
    this.taxLotGridData = rowList;
  }

  private buildTableBodyNonEditOrder(data:Array<Object>,headerText:string,body:any[]) {
    body.push([{border: [false, true, false, false],fillColor: '#eeeeee',text: headerText, style: 'tableHeader', colSpan: 4}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}]);
    data.forEach(function(row) {
      let value = Object.values(row)[0];
      if (!!value && (value !== '0.00')) {
        body.push([{text:(Object.keys(row)[0] as string),style:'tabledata1'}, {text:value, style: 'tabledata', colSpan: 3}]);
      }
    });
  }

  buildTableBody(data:Array<Object>,headerText:string,orderAction?:string) { 
    //input (Array<{label:text}>,headerText) => table)
    //input example: ([{'principal':text},{'commission':text},{'blah':text}],'foo') => table w title 'foo' and
    // rows are the objects in the array given as arg[0]
    let body = [];
    let showRow = this.showRowEditOrder;
    if (headerText === 'Estimated Transaction Value') {
      let estimatedPrincipalSubHeader = this.estimatedPrincipalSubHeader(this.tradeType,this.currencyCode);
      body.push([{border: [false, true, false, false],fillColor: '#eeeeee',text: 'Estimated Transaction Value', style: 'tableHeader',noWrap:true}, {fillColor: '#eeeeee',text: estimatedPrincipalSubHeader, style: 'tableHeader2',margin:[40,5,0,0]},{fillColor: '#eeeeee',text: '', style: 'tableHeader'},{fillColor: '#eeeeee',text: '', style: 'tableHeader'}]);
      data.forEach(function(row) {
        if (!!Object.values(row)[0]){
          body.push([{text:(Object.keys(row)[0] as string),style:'tabledata1'}, {text: Object.values(row)[0], style: 'tabledata', alignment:'right',margin:[0,0,130,0]}, '','']);
        }
      });
    } else if(!orderAction){
      this.buildTableBodyNonEditOrder(data,headerText,body);
      if(body.length===1) {
        body = [['','','','']];
      }
    } else {
      let editHeader = this.changeOrCorrect(orderAction);
      body.push([{border: [false, true, false, false],fillColor: '#eeeeee',text: headerText, style: 'tableHeader', colSpan: 4}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}]);
      body.push(['',{text:'Original Order',style:'tabledata1'},'',{text:editHeader,style:'tabledata1'}]);
      data.forEach(function(row) { 
        let origOrderVal = Object.values(row)[0][0];
        let orderVal = Object.values(row)[0][1];
        if (showRow(orderVal,origOrderVal)) {
          body.push([{text:(Object.keys(row)[0] as string),style:'tabledata1'}, {text:origOrderVal, style: 'tabledata'},'',{text: orderVal, style: 'tabledata'}]);
        }
      });
      if (body.length === 2) {
        body = [['','','','']];
      }
    }
    return body;
  }

  private estimatedPrincipalSubHeader(tradeType:string,currencyCode:string) {
    let subHeader = '';
    if (!this.isNonDollar) {
      subHeader = '(All Values in USD)';
    } else if (tradeType==='EQUITY') {
      subHeader = 'In Local Currency (' + currencyCode + ')';
    } else {
      // must be mutual fund or options non dollar trade
      subHeader = '(All Values in ' + currencyCode + ')';
    }
    return subHeader;
  }

  private changeOrCorrect(orderAction:string): string {
    if (!!this.isComplex && !!this.optionTradingUtils.optionLegSymbol.length) {
      return 'Changed To';
    }
    if (orderAction==='CHANGE') {
      return 'Changed Order';
    } else {
      return 'Corrected Order';
    }
  }


  private showRowEditOrder(orderVal:string,origOrderVal:string): boolean {
    if ((!!orderVal && (orderVal !== '0.00')) || (origOrderVal && (origOrderVal !== '0.00'))) {
      return true;
    } else {
      return false
    };
  }

  private processCalcCommission(commAmt:any,isBdUser:boolean) {
    if (!isBdUser || this.isNonDollar || (commAmt === '')) {
      return '';
    } else {
      return this.splitRegExPlusNum(+commAmt);
    }
  }

  private processCalcCommissionMutualFund(commAmt:any,isBdUser:boolean) {
    if (!isBdUser || (commAmt === '')) {
      return '';
    } else {
      return this.splitRegExPlusNum(+commAmt);
    }
  }

  private processCalcFeesMutualFund(fees:any,isBdUser:boolean) {
    if (!isBdUser || (fees === '')) {
      return '';
    } else {
      return this.splitRegExPlusNum(+fees);
    }
  }

  private processCalcFees(fees:any,isBdUser:boolean) {
    if (!isBdUser || this.isNonDollar || (fees === '')) {
      return '';
    } else {
      return this.splitRegExPlusNum(+fees);
    }
  }

  private optionPdf(order: any,entitlements:TradingEntitlements): Object {
          if (!entitlements.isEntitledToComplexOption  || !this.optionTradingUtils.optionLegSymbol?.length) {
            this.logService.log('REGULAR OPTIONS: professional user, non edit order');
            return {
            pageSize: 'Letter',
            pageOrientation: 'portrait',
            pageMargins: [40, 115, 40, 60],
            header: function() {
                return [
          
                {
                  columns: [
                  {text: order.orderstatus,alignment: 'left', style:'confirmation'},
                  {
                    image: 'data:image/png;base64,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'
                    ,alignment:'right',fit:[100,100],style:'image'
                  }    
                  ], 
                }, 
                {
                  columns: [
                  { text: order.accountName,alignment: 'left', style:'account'},
                  ], 
                }, 
                {
                  columns: [
                { text: order.accountAdress, alignment: 'left', style:'adress'},
              
                ], 
                },
                {
                  canvas: [{ type: 'line', x1: 38, y1: 14, x2: 595-22, y2: 14, lineWidth: 1 }]
                }
              ]
            },
    
            footer: function(currentPage, pageCount) { 
                return [
            
                {
                  canvas: [{ type: 'line', x1: 38, y1: 5, x2: 595-22, y2: 5, lineWidth: 1 }]
                },
                {
                  table: {
                    headerRows: 1,
                    widths: [500, 100],
                    body: [
                    [{ text: order.preparedBy,alignment: 'left', style:'preparedby' },
                      { text: currentPage.toString() + ' of ' + pageCount, alignment: 'right',style:'preparedby'  }
                      ]
                    ]
            },
          layout: 'noBorders', style:'footer'
              }]   
      },
      content: [  
            
      {   
              text: order.orderProcessing,  
              style: 'following'  
          }, 
      {  
              text: order.orderDescription,  
              style: 'transaction'  
          }, 
      {  
              text: order.quoteDescriptionCusip,  
              style: 'symbolName'  
          }, 
      {  
              text: order.orderPlacedon,  
              style: 'orderplaced'  
          },

          {
            style: 'tableOrderDetails',
            table: {
              headerRows: 1,
              widths: [ 135, 'auto', 'auto', '*' ],
              body: this.buildTableBody(
                [{'Principal:':this.splitRegExPlusNum(order.principalAmt)},
                {'Commission:':this.processCalcCommission(order.calculatedCommAmt,entitlements.isBdUser)},
                {'Fees:':this.processCalcFees(order.totalFee,entitlements.isBdUser)},
                {'Total:':this.splitRegExPlusNum(order.netAmt)}
              ],'Estimated Transaction Value')
            },
            layout: 'lightHorizontalLines'
          },
          
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, 'auto', '*', '*' ],
          body: this.buildTableBody([
            {'Expiration Date:': order.expirationDate},
            {'Strike Price:':order.strikePrice},
            {'Order Type:':order.orderType},
            {'Stop Price:':this.splitRegExPlusNum(+order.stopPrice)},
            {'Limit Price:':this.splitRegExPlusNum(+order.limitPrice)},
            {'Duration:':order.duration},
            {'Cust/Firm Ind:':order.custFirmInd},
            {'Account Type:':order.accountType},
            {'Solicited:':order.solicited},
            {'Discretion:':order.discExercised},
            {'CAT Entity:':this.orderlegalEntity?.shortName}
          ],'Order Details')
        },
        layout: 'lightHorizontalLines'
      },
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.buildTableBody([
            {'Order Qualifier:':order.addlOrdData},
            {'Memo:':order.addlIbdMemo.trim()},
            {'Trailers / Comments on Confirm:':order.trailer.trim()},
            {'Source of Input:': order.sourceOverride}
          ],'Additional Order Information')
        },
        layout: 'lightHorizontalLines'
      },
      {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.buildTableBody([
            {'Commission:':order.commType},
            {'Value:':order.commissionAmt},
            (order.splitIP1 + ' ' +order.splitIP1Pct).trim() !== ''?{'IP1 Override:':order.splitIP1 + ' ' +order.splitIP1Pct}:{'':''},
            (order.splitIP2 + ' ' +order.splitIP2Pct).trim() !== ''?{'IP2 Override:':order.splitIP2 + ' ' +order.splitIP2Pct}:{'':''}
          ],'Commission & IP Override')
        },
        layout: 'lightHorizontalLines'
      },
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.buildTableBody([
            !!order.secIbdOrdRcvDate.trim()?{'Order Receipt Date/Time:':order.secIbdOrdRcvDate}:{'':''},
            {'Order Received From:':order.secIbdOrdRcvFromName.trim()},
            {'Notes':order.secTermsAndConditions.trim()},
          ],'Regulatory Information')
        },
        layout: 'lightHorizontalLines'
      },{
        style: {margin:[0,5,0,0]},
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.taxLotBody
        },
        layout: 'lightHorizontalLines'
      },
      {
        style: {margin:[0,0,0,0]},
        table: {
          headerRows: 0,
          widths: [ 135, '*', '*', '*' ],
          body: this.taxLotGrid
        },
      },
    
            {  
                text: 'Disclaimer:',  
              style: 'disclaimer',alignment: 'left'  
          },
          {  
              text: disclaimer,  
              style: 'disclaimerText',alignment: 'left'  
          },
          
        
      
      ],  
      styles: {  
          footer: {  
              
              margin: [0, 5, 0, 5]  
          }, 
            confirmation: {  
              bold: true,  
              fontSize: 15,  
              margin: [40, 15, 0, 5]  
          }, 
            image: {  
              bold: true,  
              fontSize: 15,  
              margin: [40, 10, 0, 5]  
          }, 
          account: {  
              bold: true,  
              fontSize: 12,  
              margin: [40, 0, 0, 0]  
          }, 
            adress: {  
              margin: [40, 0, 30, 0]  
          }, 
          following: {  
              fontSize: 10,  
              margin: [0, 5, 0, 0]  
          }, 
          transaction: {  
              color: order.orderTitleStyle,
              bold: true,  
              fontSize: 14,  
              margin: [0, 0, 0, 0]  
          },
          symbolName: {  
              bold: true,  
              fontSize: 12,  
              margin: [0, 0, 0, 0]  
          },
          orderplaced: {  
              color: 'gray',
              fontSize: 12,  
              margin: [0, 0, 0, 15]  
          },
            tableHeader: {  
              bold: true, 
              color: 'black',
              fontSize: 12,  
              margin: [0, 0, 0, 0]  
          },
          tableHeader2: {  
            bold: true, 
            color: 'black',
            fontSize: 8,  
            margin: [0, 5, 0, 0]  
        },
          tabledata: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 0, 0]  
          },
          tabledata1: {  
            bold: false,  
            fontSize: 10,  
            margin: [0, 0, 0, 0]  
        },
            tableOrderDetails: {  
              margin: [0, 5, 0, 5]
          },
          disclaimer: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 30, 0]    
          },
            disclaimerText: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 0, 0],
          },
          preparedby: {  
              color: 'gray',
              fontSize: 10,  
              margin: [40, 0, 30, 0]  
          },
          sectionHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 13,  
              margin: [0, 15, 0, 15]  
          } 
      } 
      } 
    } else {
            this.logService.log('COMPLEX OPTIONS: professional user, non edit order');
            return {
            pageSize: 'Letter',
            pageOrientation: 'portrait',
            pageMargins: [40, 115, 40, 60],
            header: function() {
                return [
          
                {
                  columns: [
                  {text: order.orderstatus,alignment: 'left', style:'confirmation'},
                  {
                    image: 'data:image/png;base64,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'
                    ,alignment:'right',fit:[100,100],style:'image'
                  }    
                  ], 
                }, 
                {
                  columns: [
                  { text: order.accountName,alignment: 'left', style:'account'},
                  ], 
                }, 
                {
                  columns: [
                { text: order.accountAdress, alignment: 'left', style:'adress'},
              
                ], 
                },
                {
                  canvas: [{ type: 'line', x1: 38, y1: 14, x2: 595-22, y2: 14, lineWidth: 1 }]
                }
              ]
            },
    
            footer: function(currentPage, pageCount) { 
                return [
            
                {
                  canvas: [{ type: 'line', x1: 38, y1: 5, x2: 595-22, y2: 5, lineWidth: 1 }]
                },
                {
                  table: {
                    headerRows: 1,
                    widths: [500, 100],
                    body: [
                    [{ text: order.preparedBy,alignment: 'left', style:'preparedby' },
                      { text: currentPage.toString() + ' of ' + pageCount, alignment: 'right',style:'preparedby'  }
                      ]
                    ]
            },
          layout: 'noBorders', style:'footer'
              }]   
      },
      content: [  
            
      {   
              text: order.orderProcessing,  
              style: 'following'  
          }, 
      {  
              text: order.orderDescription,  
              style: 'transaction'  
          }, 
      {  
              text: order.quoteDescriptionCusip,  
              style: 'symbolName'  
          }, 
      {  
              text: order.orderPlacedon,  
              style: 'orderplaced'  
          },

          {
            style: 'tableOrderDetails',
            table: {
              headerRows: 1,
              widths: [ 135, 'auto', 'auto', '*' ],
              body: this.buildTableBody(
                [{'Order Value:':this.splitRegExPlusNum(Math.abs(order.principalAmt))},
                order.strategy==='Single Order'?{'Commission:':this.processCalcCommission(order.calculatedCommAmt,entitlements.isBdUser)}:{'Commission Leg 1:':this.processCalcCommission(order.calculatedComplexCommAmtEstPrincipal[0],entitlements.isBdUser)},
                order.strategy==='Single Order'?{'':''}:{'Commission Leg 2:':this.processCalcCommission(order.calculatedComplexCommAmtEstPrincipal[1],entitlements.isBdUser)},
                {'Fees:':this.processCalcFees(order.totalFee,entitlements.isBdUser)},
                {'Total:':this.splitRegExPlusNum(Math.abs(order.netAmt))}
              ],'Estimated Transaction Value')
            },
            layout: 'lightHorizontalLines'
          },

          {
            style: 'tableOrderDetails',
            table: {
              body: this.buildComplexGrid(order)
            }
          },
          
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, 'auto', '*', '*' ],
          body: this.buildTableBody([
            {'Order Type:':order.orderType},
            {'Stop Price:':this.splitRegExPlusNum(+order.stopPrice)},
            {'Limit Price:':this.splitRegExPlusNum(+order.limitPrice)},
            {'Duration:':order.duration},
            {'Cust/Firm Ind:':order.custFirmInd},
            {'Solicited:':order.solicited},
            {'Discretion:':order.discExercised},
            {'CAT Entity:':this.orderlegalEntity?.shortName}
          ],'Order Details')
        },
        layout: 'lightHorizontalLines'
      },
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.buildTableBody([
            {'Order Qualifier:':order.addlOrdData},
            {'Memo:':order.addlIbdMemo.trim()},
            {'Trailers / Comments on Confirm:':order.trailer.trim()},
            {'Source of Input:': order.sourceOverride}
          ],'Additional Order Information')
        },
        layout: 'lightHorizontalLines'
      },
      {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.buildTableBody(this.buildMultiLegCommData(order),'Commission & IP Override')
        },
        layout: 'lightHorizontalLines'
      },
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.buildTableBody([
            !!order.secIbdOrdRcvDate.trim()?{'Order Receipt Date/Time:':order.secIbdOrdRcvDate}:{'':''},
            {'Order Received From:':order.secIbdOrdRcvFromName.trim()},
            {'Notes':order.secTermsAndConditions.trim()},
          ],'Regulatory Information')
        },
        layout: 'lightHorizontalLines'
      },{
        style: {margin:[0,5,0,0]},
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.taxLotBody
        },
        layout: 'lightHorizontalLines'
      },
      {
        style: {margin:[0,0,0,0]},
        table: {
          headerRows: 0,
          widths: [ 135, '*', '*', '*' ],
          body: this.taxLotGrid
        },
      },
    
            {  
                text: 'Disclaimer:',  
              style: 'disclaimer',alignment: 'left'  
          },
          {  
              text: disclaimer,  
              style: 'disclaimerText',alignment: 'left'  
          },
          
        
      
      ],  
      styles: {  
          footer: {  
              
              margin: [0, 5, 0, 5]  
          }, 
            confirmation: {  
              bold: true,  
              fontSize: 15,  
              margin: [40, 15, 0, 5]  
          }, 
            image: {  
              bold: true,  
              fontSize: 15,  
              margin: [40, 10, 0, 5]  
          }, 
          account: {  
              bold: true,  
              fontSize: 12,  
              margin: [40, 0, 0, 0]  
          }, 
            adress: {  
              margin: [40, 0, 30, 0]  
          }, 
          following: {  
              fontSize: 10,  
              margin: [0, 5, 0, 0]  
          }, 
          transaction: {  
              color: order.orderTitleStyle,
              bold: true,  
              fontSize: 14,  
              margin: [0, 0, 0, 0]  
          },
          symbolName: {  
              bold: true,  
              fontSize: 12,  
              margin: [0, 0, 0, 0]  
          },
          orderplaced: {  
              color: 'gray',
              fontSize: 12,  
              margin: [0, 0, 0, 15]  
          },
            tableHeader: {  
              bold: true, 
              color: 'black',
              fontSize: 12,  
              margin: [0, 0, 0, 0]  
          },
          tableHeader2: {  
            bold: true, 
            color: 'black',
            fontSize: 8,  
            margin: [0, 5, 0, 0]  
        },
          tabledata: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 0, 0]  
          },
          tabledata1: {  
            bold: false,  
            fontSize: 10,  
            margin: [0, 0, 0, 0]  
        },
            tableOrderDetails: {  
              margin: [0, 5, 0, 5]
          },
          disclaimer: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 30, 0]    
          },
            disclaimerText: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 0, 0],
          },
          preparedby: {  
              color: 'gray',
              fontSize: 10,  
              margin: [40, 0, 30, 0]  
          },
          sectionHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 13,  
              margin: [0, 15, 0, 15]  
          } 
      } 
      } 
    }
  };

  private buildMultiLegCommData(order:any) {
    let data:any[] = [];
    data = [
      order.strategy==='Single Order'?{'Commission:':order.commType}:{'Commission Leg 1:':order.legCommType[0]},
      order.strategy==='Single Order'?{'Value:':order.commissionAmt}:{'Value:':order.legCommissionAmt[0]},
      order.strategy==='Single Order'?{'':''}:{'Commission Leg 2:':order.legCommType[1]},
      order.strategy==='Single Order'?{'':''}:{'Value:':order.legCommissionAmt[1]},
      (order.splitIP1 + ' ' +order.splitIP1Pct).trim() !== ''?{'IP1 Override:':order.splitIP1 + ' ' +order.splitIP1Pct}:{'':''},
      (order.splitIP2 + ' ' +order.splitIP2Pct).trim() !== ''?{'IP2 Override:':order.splitIP2 + ' ' +order.splitIP2Pct}:{'':''}
    ];
    return data;
  }

  private createSingleGrid(order:any,origOrder:any,body:any[],header:string,editHeaders:string[]) {
    if (!!origOrder?.ordDtlKey) {
       if (!!this.optionTradingUtils.hasQuantityEdited) {
         body.push([{text:'Transaction',colSpan:1,style:'tabledata1'},{text:'Symbol',colSpan:1,style:'tabledata1'},{text:editHeaders[0],colSpan:1,style:'tabledata1'},{text:editHeaders[1],colSpan:1,style:'tabledata1'},{text:'Account Type',colSpan:1,style:'tabledata1'}])
         body.push([{text:order.transactionType[0],style:'tabledata',colSpan:1}, {text:order.symbol[0],style:'tabledata',colSpan:1},{text:order.editOrdQty[0],style:'tabledata',colSpan:1},{text:order.ordQty[0],style:'tabledata',colSpan:1},{text:order.accountType[0],style:'tabledata',colSpan:1}]);

       } else {
         body.push([{text:'Transaction',colSpan:1,style:'tabledata1'},{text:'Symbol',colSpan:1,style:'tabledata1'},{text:editHeaders[0],colSpan:1,style:'tabledata1'},{text:'Account Type',colSpan:1,style:'tabledata1'}])
         body.push([{text:order.transactionType[0],style:'tabledata',colSpan:1}, {text:order.symbol[0],style:'tabledata',colSpan:1},{text:order.editOrdQty[0],style:'tabledata',colSpan:1},{text:order.accountType[0],style:'tabledata',colSpan:1}]);

       }
     } else {
       body.push([{text:'Transaction',colSpan:1,style:'tabledata1'},{text:'Symbol',colSpan:1,style:'tabledata1'},{text:header,colSpan:1,style:'tabledata1'},{text:'Account Type',colSpan:1,style:'tabledata1'}])
       body.push([{text:order.transactionType[0],style:'tabledata',colSpan:1}, {text:order.symbol[0],style:'tabledata',colSpan:1},{text:order.ordQty[0],style:'tabledata',colSpan:1},{text:order.accountType[0],style:'tabledata',colSpan:1}]);
     }
  }

  private createOptEqtGrid(order:any,origOrder:any,body:any[],header:string,editHeaders:string[]) {
    if (!!origOrder?.ordDtlKey) {
      if (!!this.optionTradingUtils.hasQuantityEdited) {
        body.push([{text:'Leg #',colSpan:1,style:'tabledata1'},{text:'Transaction',colSpan:1,style:'tabledata1'},{text:'Symbol',colSpan:1,style:'tabledata1'},{text:editHeaders[0],colSpan:1,style:'tabledata'},{text:editHeaders[1],colSpan:1,style:'tabledata1'},{text:'Account Type',colSpan:1,style:'tabledata1'}]);
        for ( let i: number = 0; i < this.optionTradingUtils.optionLegSymbol.length; i++ ) { 
          body.push([{text:(i+1).toString(),style:'tabledata',colSpan:1},{text:order.transactionType[i],style:'tabledata',colSpan:1}, {text:order.symbol[i],style:'tabledata',colSpan:1},{text:order.editOrdQty[i],style:'tabledata',colSpan:1},{text:order.ordQty[i],style:'tabledata',colSpan:1},{text:order.accountType[i],style:'tabledata',colSpan:1}]);
        }
      } else {
        body.push([{text:'Leg #',colSpan:1,style:'tabledata1'},{text:'Transaction',colSpan:1,style:'tabledata1'},{text:'Symbol',colSpan:1,style:'tabledata1'},{text:editHeaders[0],colSpan:1,style:'tabledata1'},{text:'Account Type',colSpan:1,style:'tabledata1'}]);
        for ( let i: number = 0; i < this.optionTradingUtils.optionLegSymbol.length; i++ ) { 
          body.push([{text:(i+1).toString(),style:'tabledata',colSpan:1},{text:order.transactionType[i],style:'tabledata',colSpan:1}, {text:order.symbol[i],style:'tabledata',colSpan:1},{text:order.editOrdQty[i],style:'tabledata',colSpan:1},{text:order.accountType[i],style:'tabledata',colSpan:1}]);
        }
      }
    } else {
      body.push([{text:'Leg #',colSpan:1,style:'tabledata1'},{text:'Transaction',colSpan:1,style:'tabledata1'},{text:'Symbol',colSpan:1,style:'tabledata1'},{text:header,colSpan:1,style:'tabledata1'},{text:'Account Type',colSpan:1,style:'tabledata1'}])
      for ( let i: number = 0; i < this.optionTradingUtils.optionLegSymbol.length; i++ ) { 
        body.push([{text:(i+1).toString(),style:'tabledata',colSpan:1},{text:order.transactionType[i],style:'tabledata',colSpan:1}, {text:order.symbol[i],style:'tabledata',colSpan:1},{text:order.ordQty[i],style:'tabledata',colSpan:1},{text:order.accountType[i],style:'tabledata',colSpan:1}]);
      }
    }
  }

  private createMultiLegOptGrid(order:any,origOrder:any,body:any[],header:string,editHeaders:string[]) {
    if (!!origOrder?.ordDtlKey) {
      if (!!this.optionTradingUtils.hasQuantityEdited) {
        body.push([{text:'Leg #',colSpan:1,style:'tabledata1'},{text:'Transaction',colSpan:1,style:'tabledata1'},{text:'Symbol',colSpan:1,style:'tabledata1'},{text:editHeaders[0],colSpan:1,style:'tabledata1'},{text:editHeaders[1],colSpan:1,style:'tabledata1'},{text:'Account Type',colSpan:1,style:'tabledata1'}])
        for ( let i: number = 0; i < this.optionTradingUtils.optionLegSymbol.length; i++ ) { 
          body.push([{text:(i+1).toString(),style:'tabledata',colSpan:1},{text:order.transactionType[i],style:'tabledata',colSpan:1}, {text:order.symbol[i],style:'tabledata',colSpan:1},{text:order.editOrdQty[i],style:'tabledata',colSpan:1},{text:order.ordQty[i],style:'tabledata',colSpan:1},{text:order.accountType[i],style:'tabledata',colSpan:1}]);
        }
      } else {
        body.push([{text:'Leg #',colSpan:1,style:'tabledata1'},{text:'Transaction',colSpan:1,style:'tabledata1'},{text:'Symbol',colSpan:1,style:'tabledata1'},{text:editHeaders[0],colSpan:1,style:'tabledata1'},{text:'Account Type',colSpan:1,style:'tabledata1'}])
        for ( let i: number = 0; i < this.optionTradingUtils.optionLegSymbol.length; i++ ) { 
          body.push([{text:(i+1).toString(),style:'tabledata',colSpan:1},{text:order.transactionType[i],style:'tabledata',colSpan:1}, {text:order.symbol[i],style:'tabledata',colSpan:1},{text:order.editOrdQty[i],style:'tabledata',colSpan:1},{text:order.accountType[i],style:'tabledata',colSpan:1}]);
        }
      }
    } else {
      body.push([{text:'Leg #',colSpan:1,style:'tabledata1'},{text:'Transaction',colSpan:1,style:'tabledata1'},{text:'Symbol',colSpan:1,style:'tabledata1'},{text:header,colSpan:1,style:'tabledata1'},{text:'Account Type',colSpan:1,style:'tabledata1'}])
      for ( let i: number = 0; i < this.optionTradingUtils.optionLegSymbol.length; i++ ) { 
        body.push([{text:(i+1).toString(),style:'tabledata',colSpan:1},{text:order.transactionType[i],style:'tabledata',colSpan:1}, {text:order.symbol[i],style:'tabledata',colSpan:1},{text:order.ordQty[i],style:'tabledata',colSpan:1},{text:order.accountType[i],style:'tabledata',colSpan:1}]);
      }
    }
  }

  private buildComplexGrid(order:any,origOrder?:any) {
    let body = [];
    let header=this.optionTradingUtils.getHeader(order);
    let editHeaders = this.optionTradingUtils.getHeadersEditOrder(order);
      if (['Single Order'].includes(order.strategy)) {
        this.createSingleGrid(order,origOrder,body,header,editHeaders);
      } else if(['Buy-Write','Married-Put'].includes(order.strategy)){
        this.createOptEqtGrid(order,origOrder,body,header,editHeaders);
      } else {
        this.createMultiLegOptGrid(order,origOrder,body,header,editHeaders);
      }
    return body;
  }


    private equityPdf(order: any,entitlements:TradingEntitlements): Object {
            this.logService.log('EQUITY: professional user, non edit order');
            return {
            pageSize: 'Letter',
            pageOrientation: 'portrait',
            pageMargins: [40, 115, 40, 60],
            header: function() {
                return [
          
                {
                  columns: [
                  {text: order.orderstatus,alignment: 'left', style:'confirmation'},
                  {
                    image: 'data:image/png;base64,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'
                    ,alignment:'right',fit:[100,100],style:'image'
                  }    
                  ], 
                }, 
                {
                  columns: [
                  { text: order.accountName,alignment: 'left', style:'account'},
                  ], 
                }, 
                {
                  columns: [
                { text: order.accountAdress, alignment: 'left', style:'adress'},
              
                ], 
                },
                {
                  canvas: [{ type: 'line', x1: 38, y1: 14, x2: 595-22, y2: 14, lineWidth: 1 }]
                }
              ]
            },
    
            footer: function(currentPage, pageCount) { 
                return [
            
                {
                  canvas: [{ type: 'line', x1: 38, y1: 5, x2: 595-22, y2: 5, lineWidth: 1 }]
                },
                {
                  table: {
                    headerRows: 1,
                    widths: [500, 100],
                    body: [
                    [{ text: order.preparedBy,alignment: 'left', style:'preparedby' },
                      { text: currentPage.toString() + ' of ' + pageCount, alignment: 'right',style:'preparedby'  }
                      ]
                    ]
            },
          layout: 'noBorders', style:'footer'
              }]   
      },
      content: [  
            
      {   
              text: order.orderProcessing,  
              style: 'following'  
          }, 
      {  
              text: order.orderDescription,  
              style: 'transaction'  
          }, 
      {  
              text: order.quoteDescriptionCusip,  
              style: 'symbolName'  
          }, 
      {  
              text: order.orderPlacedon,  
              style: 'orderplaced'  
          },

          {
            style: 'tableOrderDetails',
            table: {
              headerRows: 1,
              widths: [ 135, 'auto', 'auto', '*' ],
              body: this.buildTableBody(
                [{'Principal:':this.splitRegExPlusNum(order.principalAmt)},
                {'Commission:':this.processCalcCommission(order.calculatedCommAmt,entitlements.isBdUser)},
                {'Fees:':this.processCalcFees(order.totalFee,entitlements.isBdUser)},
                {'Total:':this.splitRegExPlusNum(order.netAmt)}
              ],'Estimated Transaction Value')
            },
            layout: 'lightHorizontalLines'
          },
          
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, 'auto', '*', '*' ],
          body: this.buildTableBody([
            {'Order Type:':order.orderType},
            {'Stop Price:':this.splitRegExPlusNum(+order.stopPrice)},
            {'Limit Price:':this.splitRegExPlusNum(+order.limitPrice)},
            {'Trailing Amount $':this.splitRegExPlusNum(+order.trailDollarQty)},
            {'Trailing Amount %': this.splitRegExPlusNum(+order.trailPctQty)},
            {'Limit Offset $:':this.splitRegExPlusNum(+order.limitOffset)},
            {'Trailing Based On:':order.trailingBasedOn},
            {'Settle Currency:':order.settlementCcy.trim()},
            order.transactionType==='Sell Short'?{'Short Sale Locate:':order.docLocation}:{'Location:':order.docLocation},
            {'Duration:':order.duration},
            {'Account Type:':order.accountType},
            {'Solicited:':order.solicited},
            {'Discretion:':order.discExercised},
            {'CAT Entity:':this.orderlegalEntity?.shortName}
          ],'Order Details')
        },
        layout: 'lightHorizontalLines'
      },
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.buildTableBody([
            {'Order Qualifier:':order.addlOrdData},
            {'Order Instructions:':order.floorInst},
            {'Acting As:':order.paInd},
            {'Memo:':order.addlIbdMemo.trim()},
            {'Trailers / Comments on Confirm:':order.trailer.trim()},
            {'Source of Input:': order.sourceOverride}
          ],'Additional Order Information')
        },
        layout: 'lightHorizontalLines'
      },
      {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.buildTableBody([
            {'Commission:':order.commType},
            {'Value:':order.commissionAmt},
            (order.splitIP1 + ' ' +order.splitIP1Pct).trim() !== ''?{'IP1 Override:':order.splitIP1 + ' ' +order.splitIP1Pct}:{'':''},
            (order.splitIP2 + ' ' +order.splitIP2Pct).trim() !== ''?{'IP2 Override:':order.splitIP2 + ' ' +order.splitIP2Pct}:{'':''}
          ],'Commission & IP Override')
        },
        layout: 'lightHorizontalLines'
      },
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.buildTableBody([
            !!order.secIbdOrdRcvDate.trim()?{'Order Receipt Date/Time:':order.secIbdOrdRcvDate}:{'':''},
            {'Order Received From:':order.secIbdOrdRcvFromName.trim()},
            {'Notes':order.secTermsAndConditions.trim()},
            !!order.oatsDeskReceiptDate1.trim()?{'Desk Route 1 Date/Time:':order.oatsDeskReceiptDate1}:{'':''},
            {'Desk Route 1:':order.oatsDeskTypeCode1},
            {'Information Barrier 1:':order.ordXctnTxt1.trim()},
            !!order.oatsDeskReceiptDate2.trim()?{'Desk Route 2 Date/Time:':order.oatsDeskReceiptDate2}:{'':''},
            {'Desk Route 2:':order.oatsDeskTypeCode2},
            {'Information Barrier 2:':order.ordXctnTxt2.trim()}
          ],'Regulatory Information')
        },
        layout: 'lightHorizontalLines'
      }, {
        style: {margin:[0,5,0,0]},
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.taxLotBody
        },
        layout: 'lightHorizontalLines'
      },
      {
        style: {margin:[0,0,0,0]},
        table: {
          headerRows: 0,
          widths: [ 135, '*', '*', '*' ],
          body: this.taxLotGrid
        },
      },
    
            {  
                text: 'Disclaimer:',  
              style: 'disclaimer',alignment: 'left'  
          },
          {  
              text: disclaimer,  
              style: 'disclaimerText',alignment: 'left'  
          },
          
        
      
      ],  
      styles: {  
          footer: {  
              
              margin: [0, 5, 0, 5]  
          }, 
            confirmation: {  
              bold: true,  
              fontSize: 15,  
              margin: [40, 15, 0, 5]  
          }, 
            image: {  
              bold: true,  
              fontSize: 15,  
              margin: [40, 10, 0, 5]  
          }, 
          account: {  
              bold: true,  
              fontSize: 12,  
              margin: [40, 0, 0, 0]  
          }, 
            adress: {  
              margin: [40, 0, 30, 0]  
          }, 
          following: {  
              fontSize: 10,  
              margin: [0, 5, 0, 0]  
          }, 
          transaction: {  
              color: order.orderTitleStyle,
              bold: true,  
              fontSize: 14,  
              margin: [0, 0, 0, 0]  
          },
          symbolName: {  
              bold: true,  
              fontSize: 12,  
              margin: [0, 0, 0, 0]  
          },
          orderplaced: {  
              color: 'gray',
              fontSize: 12,  
              margin: [0, 0, 0, 15]  
          },
            tableHeader: {  
              bold: true, 
              color: 'black',
              fontSize: 12,  
              margin: [0, 0, 0, 0]  
          },
          tableHeader2: {  
            bold: true, 
            color: 'black',
            fontSize: 8,  
            margin: [0, 5, 0, 0]  
        },
          tabledata: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 0, 0]  
          },
          tabledata1: {  
            bold: false,  
            fontSize: 10,  
            margin: [0, 0, 0, 0]  
        },
            tableOrderDetails: {  
              margin: [0, 5, 0, 5]
          },
          disclaimer: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 30, 0]    
          },
            disclaimerText: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 0, 0],
          },
          preparedby: {  
              color: 'gray',
              fontSize: 10,  
              margin: [40, 0, 30, 0]  
          },
          sectionHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 13,  
              margin: [0, 15, 0, 15]  
          } 
      } 
      } 
  };



  private mutualFundPdf(order: any,entitlements:TradingEntitlements): Object {
                this.logService.log('MUTUAL FUND: professional user, non edit order');
            return {
            pageSize: 'Letter',
            pageOrientation: 'portrait',
            pageMargins: [40, 115, 40, 60],
            header: function() {
                return [
          
                {
                  columns: [
                  {text: order.orderstatus,alignment: 'left', style:'confirmation'},
                  {
                    image: 'data:image/png;base64,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'
                    ,alignment:'right',fit:[100,100],style:'image'
                  }    
                  ], 
                }, 
                {
                  columns: [
                  { text: order.accountName,alignment: 'left', style:'account'},
                  ], 
                }, 
                {
                  columns: [
                { text: order.accountAdress, alignment: 'left', style:'adress'},
              
                ], 
                },
                {
                  canvas: [{ type: 'line', x1: 38, y1: 14, x2: 595-22, y2: 14, lineWidth: 1 }]
                }
              ]
            },
    
            footer: function(currentPage, pageCount) { 
                return [
            
                {
                  canvas: [{ type: 'line', x1: 38, y1: 5, x2: 595-22, y2: 5, lineWidth: 1 }]
                },
                {
                  table: {
                    headerRows: 1,
                    widths: [500, 100],
                    body: [
                    [{ text: order.preparedBy,alignment: 'left', style:'preparedby' },
                      { text: currentPage.toString() + ' of ' + pageCount, alignment: 'right',style:'preparedby'  }
                      ]
                    ]
            },
          layout: 'noBorders', style:'footer'
              }]   
      },
      content: [  
            
      {   
              text: order.orderProcessing,  
              style: 'following'  
          }, 
      {  
              text: order.orderDescription,  
              style: 'transaction'  
          }, 
      {  
              text: order.quoteDescriptionCusip,  
              style: 'symbolName'  
          }, 
      {  
              text: order.orderPlacedon,  
              style: 'orderplaced'  
          },

          {
            style: 'tableOrderDetails',
            table: {
              headerRows: 1,
              widths: [ 135, 'auto', 'auto', '*' ],
              body: this.buildTableBody(
                [{'Principal:':this.splitRegExPlusNum(order.principalAmt)},
                {'Commission:':this.processCalcCommissionMutualFund(order.calculatedCommAmt,entitlements.isBdUser)},
                {'Fees:':this.processCalcFeesMutualFund(order.totalFee,entitlements.isBdUser)},
                {'Total:':this.splitRegExPlusNum(order.netAmt)}
              ],'Estimated Transaction Value')
            },
            layout: 'lightHorizontalLines'
          },
          
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, 'auto', '*', '*' ],
          body: this.buildTableBody([
            this.mutualFundTradingUtils.showBuyAtNavFirst(order.loadNoLoadInd,order.transactionType,entitlements)?{'NAV Reason:':order.buyAtNav}:{'':''},
            {'Buy at NAV:':order.eligibleToBuyAtNav},
            order.eligibleToBuyAtNav==='Yes'?{'NAV Reason:':order.buyAtNav}:{'':''},
            {'LOI Amount ($):':order.loiValue},
            {'LOI Date:':order.loiDate},
            {'Total ROA Amount:':order.roaValue},
            {'Contribution Type:':order.contributionType},
            {'Original Contribution:':order.originalContribution},
            {'Earnings:':order.earningsType},
            {'Amount:':order.earningsAmount},
            {'Distribution Type:':order.distributionType},
            {'Pay To:':order.payToType},
            {'Dividends & Capital Gains:':order.dvre},
            {'Balance Type:':order.balanceType},
            {'Solicited:':order.solicited},
            {'Discretion:':order.discExercised},
            {'Share Class Reviewed:':order.shareClassReviewed},
            {'Account Type:':order.accountType},
            {'Fund Cut Off:':order.fundCutoffTime},
            {'Fund Vest Eligible:':order.fundVestDerivedVal},
            entitlements.isRiaUser?{'Redemption Fee Waiver:':order.redemptionFeeWaiver}:{'':''},
            entitlements.isRiaUser?{'Short Settle:':order.shortSettle}:{'':''},
            entitlements.isRiaUser?{'As of Order Date:':order.asOfDate}:{'':''},
            entitlements.isRiaUser?{'Error Account Number:':order.errAcctNum}:{'':''},
          ],'Order Details')
        },
        layout: 'lightHorizontalLines'
      },
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.buildTableBody([
            {'Order Qualifier:':order.addlOrdData},
            {'Order Instructions:':order.floorInst},
            {'Acting As:':order.paInd},
            {'Memo:':order.addlIbdMemo.trim()},
            {'Over / Under:':order.overUnderIndicator},
            {'Deliver:':order.deliver},
            {'Fund Acct No.':order.fundAccountNum},
            {'Gross / Net':order.grossNetIndicator},
            entitlements.isBdUser?{'Short Settle:':order.shortSettle}:{'':''},
            {'CDSC Waiver:':order.cdscWaiver},
            entitlements.isBdUser?{'Redemption Fee Waiver:':order.redemptionFeeWaiver}:{'':''},
            {'Source of Funds:':order.sourceOfFunds},
            {'Source of Input:': order.sourceOverride},
            {'Comments:':order.trailer.trim()},
            {'FA Attestation':order.attestation},
            !entitlements.isRiaUser?{'As of Order Date:':order.asOfDate}:{'':''},
            !entitlements.isRiaUser?{'Error Account Number:':order.errAcctNum}:{'':''},
          ],'Additional Order Information')
        },
        layout: 'lightHorizontalLines'
      },
      {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.buildTableBody([
            (order.splitIP1 + ' ' +order.splitIP1Pct).trim() !== ''?{'IP1 Override:':order.splitIP1 + ' ' +order.splitIP1Pct}:{'':''},
            (order.splitIP2 + ' ' +order.splitIP2Pct).trim() !== ''?{'IP2 Override:':order.splitIP2 + ' ' +order.splitIP2Pct}:{'':''},
            {'IP Group ID':order.groupId}
          ],'Commission & IP Override')
        },
        layout: 'lightHorizontalLines'
      },
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.buildTableBody([
            !!order.secIbdOrdRcvDate.trim()?{'Order Receipt Date/Time:':order.secIbdOrdRcvDate}:{'':''},
            {'Order Received From:':order.secIbdOrdRcvFromName.trim()},
            {'Notes':order.secTermsAndConditions.trim()},
          ],'Regulatory Information')
        },
        layout: 'lightHorizontalLines'
      },{
        style: {margin:[0,5,0,0]},
        table: {
          headerRows: 1,
          widths: [ 135, '*', '*', '*' ],
          body: this.taxLotBody
        },
        layout: 'lightHorizontalLines'
      },
      {
        style: {margin:[0,0,0,0]},
        table: {
          headerRows: 0,
          widths: [ 135, '*', '*', '*' ],
          body: this.taxLotGrid
        },
      },
    
            {  
                text: 'Disclaimer:',  
              style: 'disclaimer',alignment: 'left'  
          },
          {  
              text: disclaimer,  
              style: 'disclaimerText',alignment: 'left'  
          },
          
        
      
      ],  
      styles: {  
          footer: {  
              
              margin: [0, 5, 0, 5]  
          }, 
            confirmation: {  
              bold: true,  
              fontSize: 15,  
              margin: [40, 15, 0, 5]  
          }, 
            image: {  
              bold: true,  
              fontSize: 15,  
              margin: [40, 10, 0, 5]  
          }, 
          account: {  
              bold: true,  
              fontSize: 12,  
              margin: [40, 0, 0, 0]  
          }, 
            adress: {  
              margin: [40, 0, 30, 0]  
          }, 
          following: {  
              fontSize: 10,  
              margin: [0, 5, 0, 0]  
          }, 
          transaction: {  
              color: order.orderTitleStyle,
              bold: true,  
              fontSize: 14,  
              margin: [0, 0, 0, 0]  
          },
          symbolName: {  
              bold: true,  
              fontSize: 12,  
              margin: [0, 0, 0, 0]  
          },
          orderplaced: {  
              color: 'gray',
              fontSize: 12,  
              margin: [0, 0, 0, 15]  
          },
            tableHeader: {  
              bold: true, 
              color: 'black',
              fontSize: 12,  
              margin: [0, 0, 0, 0]  
          },
          tableHeader2: {  
            bold: true, 
            color: 'black',
            fontSize: 8,  
            margin: [0, 5, 0, 0]  
        },
          tabledata: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 0, 0]  
          },
          tabledata1: {  
            bold: false,  
            fontSize: 10,  
            margin: [0, 0, 0, 0]  
        },
            tableOrderDetails: {  
              margin: [0, 5, 0, 5]
          },
          disclaimer: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 30, 0]    
          },
            disclaimerText: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 0, 0],
          },
          preparedby: {  
              color: 'gray',
              fontSize: 10,  
              margin: [40, 0, 30, 0]  
          },
          sectionHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 13,  
              margin: [0, 15, 0, 15]  
          } 
      } 
      }
  }


  private retailEquityPdf(order:any,entitlements:TradingEntitlements): Object {
            this.logService.log('retail user, non edit order');
            return {
                pageSize: 'Letter',
                pageOrientation: 'portrait',
                pageMargins: [40, 80, 40, 60],
                header: function() {
                    return [
          
                    {
                  columns: [
                  {text: order.orderstatus,alignment: 'left', style:'confirmation'},
                  {
                    text: ''
                    ,alignment:'right'
                  }    
                  ], 
                }, 
                    {
                      columns: [
                        { text: order.accountName,alignment: 'left', style:'account'},
                      ], 
                    }, 
                    {
                      columns: [
                        { text: order.accountAdress, alignment: 'left', style:'adress'},
                        
                      ], 
                    },
                    {
                      canvas: [{ type: 'line', x1: 40, y1: 10, x2: 595-22, y2: 10, lineWidth: 1 }]
                    }
                    ]
                },
    
      footer: function(currentPage, pageCount) { 
          return [
            
          {
            canvas: [{ type: 'line', x1: 38, y1: 5, x2: 595-22, y2: 5, lineWidth: 1 }]
          },
          {
          table: {
              headerRows: 1,
          widths: [500, 100],
          body: [
              [{ text: order.preparedBy,alignment: 'left', style:'preparedby' },
            { text: currentPage.toString() + ' of ' + pageCount, alignment: 'right',style:'preparedby'  }
            ]
          ]
        },
        layout: 'noBorders', style:'footer'
          }]   
      },
      content: [  
          
            
        {  
                text: order.orderProcessing,  
                style: 'following'  
            }, 
        {  
                text: order.orderDescription,  
                style: 'transaction'  
            }, 
        {  
                text: order.quoteDescriptionCusip,  
                style: 'symbolName'  
            }, 
        {  
                text: order.orderPlacedon,  
                style: 'orderplaced'  
            },

            {
              style: 'tableOrderDetails',
              table: {
                headerRows: 1,
                widths: [ 140, '*', '*', '*' ],
                body: [
                  [{border: [false, true, false, false],fillColor: '#eeeeee',text: 'Estimated Transaction Value', style: 'tableHeader', colSpan: 4}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}],
                  ['Principal:', {text: '$'+order.principalAmt, style: 'tabledata'}, '', ''],
                  ['Commission:', {text: '$'+order.calculatedCommAmt, style: 'tabledata'}, '', ''],
                  ['Fees:', {text: '$'+order.totalFee, style: 'tabledata'},'','' ],
                  ['Estimated Total Cost:', {text: '$'+order.netAmt, style: 'tabledata'},'',''],
                  ['', '', '', ''],
                ]
              },
              layout: 'lightHorizontalLines'
            },
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 140, '*', '*', '*' ],
          body: [
            [{border: [false, true, false, false],fillColor: '#eeeeee',text: 'Order Details', style: 'tableHeader', colSpan: 4}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}],
            ['Security Description:', {text: order.quoteDescription, style: 'tabledata', colSpan: 3}],
            ['Transaction:', {text: order.transactionType, style: 'tabledata'}, entitlements.isTrailingStopEnabled?'Trailing Based On:':'',{text: entitlements.isTrailingStopEnabled?order.trailingBasedOn:'', style: 'tabledata'}],
            ['Symbol:', {text: order.symbol, style: 'tabledata'}, entitlements.isTrailingStopEnabled?'Trailing Dollar Amount:':'', {text: entitlements.isTrailingStopEnabled?order.trailDollarQty:'', style: 'tabledata'}],
            ['Quantity:', {text: order.ordQty, style: 'tabledata'}, entitlements.isTrailingStopEnabled?'Trailing Percent Amount:':'', {text: entitlements.isTrailingStopEnabled?order.trailPctQty:'', style: 'tabledata'}],
            ['Order Type:', {text: order.orderType, style: 'tabledata'}, entitlements.isTrailingStopEnabled?'Limit Offset:':'', {text: entitlements.isTrailingStopEnabled?order.limitOffset:'', style: 'tabledata'}],
            ['Limit Price:', {text: order.limitPrice, style: 'tabledata'}, 'Duration:', {text: order.duration, style: 'tabledata'}],
            ['Stop Price:', {text: order.stopPrice, style: 'tabledata'}, 'Account Type:', {text: order.accountType, style: 'tabledata'}],
          ]
        },
        layout: 'lightHorizontalLines'
      },
            {  
                text: 'Disclaimer:',  
              style: 'disclaimer',alignment: 'left'  
          },
          {  
              text: disclaimer,  
              style: 'disclaimerText',alignment: 'left'  
          },
          
        
      
      ],  
      styles: {  
          footer: {  
              
              margin: [0, 5, 0, 5]  
          }, 
            confirmation: {  
              bold: true,  
              fontSize: 15,  
              margin: [40, 15, 0, 5]  
          }, 
            image: {  
              bold: true,  
              fontSize: 15,  
              margin: [40, 10, 0, 5]  
          }, 
          account: {  
              bold: true,  
              fontSize: 12,  
              margin: [40, 0, 0, 0]  
          }, 
            adress: {  
              margin: [40, 0, 30, 0]  
          }, 
          following: {  
              fontSize: 10,  
              margin: [0, 5, 0, 0]  
          }, 
          transaction: {  
              color: order.orderTitleStyle,
              bold: true,  
              fontSize: 14,  
              margin: [0, 0, 0, 0]  
          },
          symbolName: {  
              bold: true,  
              fontSize: 12,  
              margin: [0, 0, 0, 0]  
          },
          orderplaced: {  
              color: 'gray',
              fontSize: 12,  
              margin: [0, 0, 0, 15]  
          },
            tableHeader: {  
              bold: true, 
              color: 'black',
              fontSize: 12,  
              margin: [0, 0, 0, 0]  
          },
          tabledata: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 0, 0]  
          },
          tabledata1: {  
            bold: false,  
            fontSize: 10,  
            margin: [0, 0, 0, 0]  
        },
            tableOrderDetails: {  
              margin: [0, 5, 0, 5]
          },
          disclaimer: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 30, 0]    
          },
            disclaimerText: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 0, 0],
          },
          preparedby: {  
              color: 'gray',
              fontSize: 10,  
              margin: [40, 0, 30, 0]  
          },
          sectionHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 13,  
              margin: [0, 15, 0, 15]  
          } 
      }
      }
  }





  getDocumentDefinition(order: any,printOrigOrder:any,entitlements:TradingEntitlements,origOrder:TradingOrderBase): Object {
    let docDefinition = () => {
      if (entitlements.isProfessionalUser && !origOrder) {
            switch(order.tradeType) {
              case 'EQUITY': return this.equityPdf(order,entitlements);
              case 'MUTUAL_FUND':
              case 'PLAN_529FUND': return this.mutualFundPdf(order,entitlements);
              case 'OPTION': return this.optionPdf(order,entitlements);
              default: return {};
            }
      } else if(entitlements.isRetailUser && !origOrder){
        switch(order.tradeType) {
          case 'EQUITY': return this.retailEquityPdf(order,entitlements);
          default: return '';
        }  
      } else {
        return this.getDocumentDefinitionForEditOrder(order,entitlements,printOrigOrder);
      }
    }
  return docDefinition();
}

private editOrderValue(origOrderVal:any,orderVal:any): string {
    if (
      (origOrderVal!==orderVal) || 
      ((origOrderVal as string)?.trim() !== (orderVal as string)?.trim())
      ) {
      return orderVal;
    } else {
      return '';
    };
}

private editOrigOrderNumber(origOrderVal:any): string {
  if (!!origOrderVal) {
    return this.splitRegExPlusNum(+origOrderVal);
  } else {
    return origOrderVal
  }
}

private editOrderNumber(origOrderVal:any,orderVal:any): string {
  if(origOrderVal !== orderVal) {
    if(!!orderVal) {
      return this.splitRegExPlusNum(+orderVal);
    } else {
      return orderVal;
    }
  } else {
    return '';
  }
}

private editOrderNoValue(origOrderVal:any,orderVal:any): string {
  if(origOrderVal !== orderVal) {
    if (!!orderVal) {
      return orderVal;
    } else {
      return '<No Value>';
    }
  } else {
    return '';
  }
}

private editOrderIP(origOrderSplitIP:any,orderSplitIP:any,origOrderSplitIPPct:any,orderSplitIPPct:any): string {
  if ((origOrderSplitIP !== orderSplitIP) || (origOrderSplitIPPct !== orderSplitIPPct)) {
    if(!!orderSplitIP && !!orderSplitIPPct) {
      return orderSplitIP + ' ' + orderSplitIPPct;
    } else {
      return '<No Value>';
    }
  } else {
    return '';
  }
}

private editOrigOrderIP(splitIP:any,splitIPPct:any): string {
  if((splitIP + ' ' + splitIPPct).trim() !== '') {
    return splitIP + ' ' + splitIPPct;
  } else {
    return '';
  }
}

private origOrderRegInfo(orderAction:any,origOrderVal:any): string {
  return origOrderVal;
}

private valOrNoVal(orderVal:any) {
    if(!!orderVal.trim()) {
      return orderVal
    } else {
      return '<No Value>'
    }
}

private orderRegInfo(orderAction:any,orderVal:any,origOrderVal:any,checkCorrect?:boolean): string {
  if(orderAction==='CHANGE') {
    if (origOrderVal !== orderVal) {
      return this.valOrNoVal(orderVal);
    } else {
      return ''
    }
  } else {
    if (!!checkCorrect && (origOrderVal !== orderVal)) {
      return this.valOrNoVal(orderVal);
    }
    return '';
  }
}

private columnConfiguration(order:any,origOrder:any) {
  let configuration = [];
  if (!this.orderSubmittedSuccessfully) {
    configuration = [
      {
        margin: [ 0 , 0, 15, 10 ],
        width:'auto',
        text:[{text:'Original order placed on: ',style:'orderplaced2bold'},{text:order.formattedOrderPlacedDateTime, style:'orderplaced2'}]
      },
      {
        margin: [ 0 , 0, 15, 10 ],
        width:'auto',
        text: [{text:this.equityTradingUtils.processRefNumTranslation(),style:'orderplaced2bold'},{text:' ' + order.refNum, style:'orderplaced2'}]
      },
      {
        margin: [ 0 , 0, 15, 10 ],
        width:'auto',
        text: [{text:'Order Status: ',style:'orderplaced2bold'},{text:origOrder.status,style:'orderplaced2'}]
      }
    ]
  }
  return configuration
}

private editProEquityPdf(order:any,origOrder:any,entitlements:TradingEntitlements): Object {
    this.logService.log('EQUITY: professional user, edit order');
    return {
    pageSize: 'Letter',
    pageOrientation: 'portrait',
    pageMargins: [40, 115, 40, 60],
    header: function() {
        return [
  
        {
          columns: [
          {text: order.orderstatus,alignment: 'left', style:'confirmation'},
          {
            image: 'data:image/png;base64,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'
            ,alignment:'right',fit:[100,100],style: 'image'
          }    
          ], 
        }, 
        {
          columns: [
          { text: order.accountName,alignment: 'left', style:'account'},
          ], 
        }, 
        {
          columns: [
        { text: order.accountAdress, alignment: 'left', style:'adress'},
      
        ], 
        },
        {
          canvas: [{ type: 'line', x1: 38, y1: 14, x2: 595-22, y2: 14, lineWidth: 1 }]
        }
      ]
    },

    footer: function(currentPage, pageCount) { 
        return [
    
        {
          canvas: [{ type: 'line', x1: 38, y1: 5, x2: 595-22, y2: 5, lineWidth: 1 }]
        },
        {
          table: {
            headerRows: 1,
            widths: [500, 100],
            body: [
            [{ text: order.preparedBy,alignment: 'left', style:'preparedby' },
              { text: currentPage.toString() + ' of ' + pageCount, alignment: 'right',style:'preparedby'  }
              ]
            ]
    },
  layout: 'noBorders', style:'footer'
      }]   
    },
    content: [  
      
    {  
          text: order.orderProcessing,  
          style: 'following'  
      }, 
    {  
          text: order.orderDescription,  
          style: 'transaction'  
      }, 
    {  
          text: order.quoteDescriptionCusip,  
          style: 'symbolName'  
      }, 
    {  
          text: order.orderPlacedon,  
          style: 'orderplaced'  
      },
      {			columns: this.columnConfiguration(order,origOrder)},

      {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 140, 'auto', '*', '*' ],
          body: this.buildTableBody(
            [{'Principal:':this.splitRegExPlusNum(order.principalAmt)},
            {'Commission:':this.processCalcCommission(order.calculatedCommAmt,entitlements.isBdUser)},
            {'Fees:':this.processCalcFees(order.totalFee,entitlements.isBdUser)},
            {'Total:':this.splitRegExPlusNum(order.netAmt)}
          ],'Estimated Transaction Value')
        },
        layout: 'lightHorizontalLines'
        },
      {
    style: 'tableOrderDetails',
    table: {
      headerRows: 1,
      widths: [ 140, '*', 'auto', '*' ],
      body: this.buildTableBody([
      {'Quantity:':[origOrder.ordQty,this.editOrderValue(origOrder.ordQty,order.ordQty)]},
      {'Order Type:':[origOrder.orderType,this.editOrderValue(origOrder.orderType,order.orderType)]},
      {'Stop Price:':[this.editOrigOrderNumber(origOrder.stopPrice),this.editOrderNumber(origOrder.stopPrice,order.stopPrice)]},
      {'Limit Price:':[this.editOrigOrderNumber(origOrder.limitPrice),this.editOrderNumber(origOrder.limitPrice,order.limitPrice)]},
      {'Trailing Amount $':[this.editOrigOrderNumber(origOrder.trailDollarQty),this.editOrderNumber(origOrder.trailDollarQty,order.trailDollarQty)]},
      {'Trailing Amount %': [this.editOrigOrderNumber(origOrder.trailPctQty),this.editOrderNumber(origOrder.trailPctQty,order.trailPctQty)]},
      {'Limit Offset $:':[this.editOrigOrderNumber(origOrder.limitOffset),this.editOrderNumber(origOrder.limitOffset,order.limitOffset)]},
      {'Trailing Based On:':[origOrder.trailingBasedOn,this.editOrderValue(origOrder.trailingBasedOn,order.trailingBasedOn)]},
      {'Settle Currency:':[origOrder.settlementCcy.trim(),this.editOrderValue(origOrder.settlementCcy.trim(),order.settlementCcy.trim())]},
      order.transactionType==='Sell Short'?{'Short Sale Locate:':[origOrder.docLocation,this.editOrderValue(origOrder.docLocation,order.docLocation)]}:{'Location:':[origOrder.docLocation,this.editOrderValue(origOrder.docLocation,order.docLocation)]},
      {'Duration:':[origOrder.duration,this.editOrderValue(origOrder.duration,order.duration)]},
      {'Account Type:':[origOrder.editOrderAccountType,this.editOrderValue(origOrder.editOrderAccountType,order.accountType)]},
      {'Solicited:':[origOrder.solicited,this.editOrderValue(origOrder.solicited,order.solicited)]},
      {'Discretion:':[origOrder.discExercised,this.editOrderNoValue(origOrder.discExercised,order.discExercised)]},
      {'CAT Entity:':[this.origOrderlegalEntity?.shortName,this.editOrderNoValue(this.origOrderlegalEntity?.shortName,this.orderlegalEntity?.shortName)]}
    ],'Order Details',origOrder.orderAction)
      
    },
    layout: 'lightHorizontalLines'
    },
      {
    style: 'tableOrderDetails',
    table: {
      headerRows: 1,
      widths: [ 140, '*', 'auto', '*' ],
      body: this.buildTableBody([
        {'Order Qualifier:':[origOrder.addlOrdData,this.editOrderNoValue(origOrder.addlOrdData,order.addlOrdData)]},
        {'Order Instructions:':[origOrder.floorInst,this.editOrderNoValue(origOrder.floorInst,order.floorInst)]},
        {'Acting As:':[origOrder.paInd,this.editOrderNoValue(origOrder.paInd,order.paInd)]},
        {'Memo:':[origOrder.addlIbdMemo.trim(),this.editOrderNoValue(origOrder.addlIbdMemo.trim(),order.addlIbdMemo.trim())]},
        {'Trailers / Comments on Confirm:':[origOrder.trailer.trim(),this.editOrderNoValue(origOrder.trailer.trim(),order.trailer.trim())]},
        {'Source of Input:': [origOrder.sourceOverride,this.editOrderNoValue(origOrder.sourceOverride,order.sourceOverride)]}
      ],'Additional Order Information',origOrder.orderAction)
    },
    layout: 'lightHorizontalLines'
    },
    {
      style: 'tableOrderDetails',
      table: {
        headerRows: 1,
        widths: [ 140, '*', 'auto', '*' ],
        body: this.buildTableBody([
          {'Commission:':[origOrder.commType,this.editOrderNoValue(origOrder.commType,order.commType)]},
          {'Value:':[origOrder.commissionAmt,this.editOrderNoValue(origOrder.commissionAmt,order.commissionAmt)]},
          {'IP1 Override:':[this.editOrigOrderIP(origOrder.splitIP1,origOrder.splitIP1Pct),this.editOrderIP(origOrder.splitIP1,order.splitIP1,origOrder.splitIP1Pct,order.splitIP1Pct)]},
          {'IP2 Override:':[this.editOrigOrderIP(origOrder.splitIP2,origOrder.splitIP2Pct),this.editOrderIP(origOrder.splitIP2,order.splitIP2,origOrder.splitIP2Pct,order.splitIP2Pct)]},
        ],'Commission & IP Override',origOrder.orderAction)
      },
      layout: 'lightHorizontalLines'
      },
      {
    style: 'tableOrderDetails',
    table: {
      headerRows: 1,
      widths: [ 140, '*', 'auto', '*' ],
      body:this.buildTableBody(this.makeEquityEditArray(order,origOrder),'Regulatory Information',origOrder.orderAction)
    },
    layout: 'lightHorizontalLines'
    },{
      style: {margin:[0,5,0,0]},
      table: {
        headerRows: 1,
        widths: [ 135, '*', '*', '*' ],
        body: this.taxLotBody
      },
      layout: 'lightHorizontalLines'
    },
    {
      style: {margin:[0,0,0,0]},
      table: {
        headerRows: 0,
        widths: [ 135, '*', '*', '*' ],
        body: this.taxLotGrid
      },
    },

        {  
            text: 'Disclaimer:',  
          style: 'disclaimer',alignment: 'left'  
      },
      {  
          text: disclaimer,  
          style: 'disclaimerText',alignment: 'left'  
      },
      


    ],  
    styles: {  
      footer: {  
          
          margin: [0, 5, 0, 5]  
      }, 
        confirmation: {  
          bold: true,  
          fontSize: 15,  
          margin: [40, 15, 0, 5]  
      }, 
        image: {  
          bold: true,  
          fontSize: 15,  
          margin: [40, 10, 0, 5]  
      }, 
      account: {  
          bold: true,  
          fontSize: 12,  
          margin: [40, 0, 0, 0]  
      }, 
        adress: {  
          margin: [40, 0, 30, 0]  
      }, 
      following: {  
          fontSize: 10,  
          margin: [0, 5, 0, 0]  
      }, 
      transaction: {  
          color: order.orderTitleStyle,
          bold: true,  
          fontSize: 14,  
          margin: [0, 0, 0, 0]  
      },
      symbolName: {  
          bold: true,  
          fontSize: 12,  
          margin: [0, 0, 0, 0]  
      },
      orderplaced: {  
          color: 'gray',
          fontSize: 12,  
          margin: [0, 0, 0, 15]  
      },
      orderplaced2: {  
        fontSize: 10,  
        margin: [0, 0, 0, 15]  
    },
    orderplaced2bold: {  
      bold:true,
      fontSize: 10,  
      margin: [0, 0, 0, 15]  
  },
        tableHeader: {  
          bold: true, 
          color: 'black',
          fontSize: 12,  
          margin: [0, 0, 0, 0]  
      },
      tableHeader2: {  
        bold: true, 
        color: 'black',
        fontSize: 8,  
        margin: [0, 5, 0, 0]  
    },
      tabledata: {  
          bold: true,  
          fontSize: 10,  
          margin: [0, 0, 0, 0]  
      },
      tabledata1: {  
        bold: false,  
        fontSize: 10,  
        margin: [0, 0, 0, 0]  
    },
        tableOrderDetails: {  
          margin: [0, 5, 0, 5]
      },
      disclaimer: {  
          bold: true,  
          fontSize: 10,  
          margin: [0, 0, 30, 0]    
      },
        disclaimerText: {  
          bold: true,  
          fontSize: 10,  
          margin: [0, 0, 0, 0],
      },
      preparedby: {  
          color: 'gray',
          fontSize: 10,  
          margin: [40, 0, 30, 0]  
      },
      sectionHeader: {  
          bold: true,  
          decoration: 'underline',  
          fontSize: 13,  
          margin: [0, 15, 0, 15]  
      } 
    } 
    }
}

private makeEquityEditArray(order:any,origOrder:any) {
  let data:any[] = [];
  if (origOrder.orderAction!=='CHANGE') {
    data = [
      !!origOrder.secIbdOrdRcvDate.trim()?{'Order Receipt Date/Time:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.secIbdOrdRcvDate),this.orderRegInfo(origOrder.orderAction,order.secIbdOrdRcvDate,origOrder.secIbdOrdRcvDate)]}:{'':['','']},
      !!origOrder.secIbdOrdRcvFromName.trim() || !!order.secIbdOrdRcvFromName.trim()?{'Order Received From:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.secIbdOrdRcvFromName.trim()),this.orderRegInfo(origOrder.orderAction,order.secIbdOrdRcvFromName.trim(),origOrder.secIbdOrdRcvFromName.trim(),true)]}:{'':['','']},
      !!origOrder.secTermsAndConditions.trim()?{'Notes':[this.origOrderRegInfo(origOrder.orderAction,origOrder.secTermsAndConditions.trim()),this.orderRegInfo(origOrder.orderAction,order.secTermsAndConditions.trim(),origOrder.secTermsAndConditions.trim())]}:{'':['','']}
    ]
  } else {
    data = this.makeEquityCancelAndReplaceArray(order,origOrder)
  }
  return data;
}

private makeEquityCancelAndReplaceArray(order:any,origOrder:any) {
  let data:any[] = [];
  if (!!order.secIbdOrdRcvDate.trim()) {
    data.push({'Order Receipt Date/Time:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.secIbdOrdRcvDate),this.orderRegInfo(origOrder.orderAction,order.secIbdOrdRcvDate,origOrder.secIbdOrdRcvDate)]});
    data.push({'Order Received From:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.secIbdOrdRcvFromName.trim()),this.orderRegInfo(origOrder.orderAction,order.secIbdOrdRcvFromName.trim(),origOrder.secIbdOrdRcvFromName.trim())]});
    data.push({'Notes':[this.origOrderRegInfo(origOrder.orderAction,origOrder.secTermsAndConditions.trim()),this.orderRegInfo(origOrder.orderAction,order.secTermsAndConditions.trim(),origOrder.secTermsAndConditions.trim())]});
  } else {
    data.push({'':['','']});
  };
  if(!!order.oatsDeskReceiptDate1.trim()) {
    data.push({'Desk Route 1 Date/Time:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.oatsDeskReceiptDate1),this.orderRegInfo(origOrder.orderAction,order.oatsDeskReceiptDate1,origOrder.oatsDeskReceiptDate1)]});
    data.push({'Desk Route 1:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.oatsDeskTypeCode1),this.orderRegInfo(origOrder.orderAction,order.oatsDeskTypeCode1,origOrder.oatsDeskTypeCode1)]});
    !!order.ordXctnTxt1.trim()?data.push({'Information Barrier 1:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.ordXctnTxt1.trim()),this.orderRegInfo(origOrder.orderAction,order.ordXctnTxt1.trim(),origOrder.ordXctnTxt1.trim())]}):data.push({'':['','']});
  } else {
    data.push({'':['','']});
  }
  if(!!order.oatsDeskReceiptDate2.trim()) {
    data.push({'Desk Route 2 Date/Time:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.oatsDeskReceiptDate2),this.orderRegInfo(origOrder.orderAction,order.oatsDeskReceiptDate2,origOrder.oatsDeskReceiptDate2)]});
    data.push({'Desk Route 2:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.oatsDeskTypeCode2),this.orderRegInfo(origOrder.orderAction,order.oatsDeskTypeCode2,origOrder.oatsDeskTypeCode2)]});
    !!order.ordXctnTxt2.trim()?data.push({'Information Barrier 2:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.ordXctnTxt2.trim()),this.orderRegInfo(origOrder.orderAction,order.ordXctnTxt2.trim(),origOrder.ordXctnTxt2.trim())]}):data.push({'':['','']});
  } else {
    data.push({'':['','']});
  }
  return data
}

private makeOptionEditRegInfoArray(order:any,origOrder:any) {
  let data:any[] = [];
  if (origOrder.orderAction!=='CHANGE') {
    data = [
      !!origOrder.secIbdOrdRcvDate.trim()?{'Order Receipt Date/Time:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.secIbdOrdRcvDate),this.orderRegInfo(origOrder.orderAction,order.secIbdOrdRcvDate,origOrder.secIbdOrdRcvDate)]}:{'':['','']},
      !!origOrder.secIbdOrdRcvFromName.trim() || !!order.secIbdOrdRcvFromName.trim()?{'Order Received From:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.secIbdOrdRcvFromName.trim()),this.orderRegInfo(origOrder.orderAction,order.secIbdOrdRcvFromName.trim(),origOrder.secIbdOrdRcvFromName.trim(),true)]}:{'':['','']},
      !!origOrder.secTermsAndConditions.trim()?{'Notes':[this.origOrderRegInfo(origOrder.orderAction,origOrder.secTermsAndConditions.trim()),this.orderRegInfo(origOrder.orderAction,order.secTermsAndConditions.trim(),origOrder.secTermsAndConditions.trim())]}:{'':['','']}
    ]
  } else {
    data = this.makeOptionCancelAndReplaceArray(order,origOrder);
  }
  return data;
}

private makeOptionCancelAndReplaceArray(order:any,origOrder:any) { 
  let data:any[] = []; 

  //FIXME - only reason for same code for complex or not complex is because seems at the moment of this comment the review screen logic for showing reg info in multileg is pretty wonky
  //(example, if you don't fill in any reg info, the review screen still shows notes and ordrcvfrom but only notes shows no-value), will deal with if any comments come during code freeze
  //so workaround logic is same as non multileg for now, instead of hacking it to conform to the review screen I am having the pdf say the truth.
  !!order.secIbdOrdRcvDate.trim()?data.push({'Order Receipt Date/Time:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.secIbdOrdRcvDate),this.orderRegInfo(origOrder.orderAction,order.secIbdOrdRcvDate,origOrder.secIbdOrdRcvDate)]}):data.push({'':['','']});
  !!origOrder.secIbdOrdRcvFromName.trim() || !!order.secIbdOrdRcvFromName.trim()?data.push({'Order Received From:':[this.origOrderRegInfo(origOrder.orderAction,origOrder.secIbdOrdRcvFromName.trim()),this.orderRegInfo(origOrder.orderAction,order.secIbdOrdRcvFromName.trim(),origOrder.secIbdOrdRcvFromName.trim())]}):data.push({'':['','']});
  !!origOrder.secTermsAndConditions.trim() || !!order.secTermsAndConditions.trim()?data.push({'Notes':[this.origOrderRegInfo(origOrder.orderAction,origOrder.secTermsAndConditions.trim()),this.orderRegInfo(origOrder.orderAction,order.secTermsAndConditions.trim(),origOrder.secTermsAndConditions.trim())]}):data.push({'':['','']});

  return data;
}



private editProOptionsPdf(order:any,origOrder:any,entitlements:TradingEntitlements): Object {
  if (!entitlements.isEntitledToComplexOption || !this.optionTradingUtils.optionLegSymbol?.length) {
    this.logService.log('Regular OPTIONS: professional user, edit order');
    return {
    pageSize: 'Letter',
    pageOrientation: 'portrait',
    pageMargins: [40, 115, 40, 60],
    header: function() {
        return [
  
        {
          columns: [
          {text: order.orderstatus,alignment: 'left', style:'confirmation'},
          {
            image: 'data:image/png;base64,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'
            ,alignment:'right',fit:[100,100],style: 'image'
          }    
          ], 
        }, 
        {
          columns: [
          { text: order.accountName,alignment: 'left', style:'account'},
          ], 
        }, 
        {
          columns: [
        { text: order.accountAdress, alignment: 'left', style:'adress'},
      
        ], 
        },
        {
          canvas: [{ type: 'line', x1: 38, y1: 14, x2: 595-22, y2: 14, lineWidth: 1 }]
        }
      ]
    },

    footer: function(currentPage, pageCount) { 
        return [
    
        {
          canvas: [{ type: 'line', x1: 38, y1: 5, x2: 595-22, y2: 5, lineWidth: 1 }]
        },
        {
          table: {
            headerRows: 1,
            widths: [500, 100],
            body: [
            [{ text: order.preparedBy,alignment: 'left', style:'preparedby' },
              { text: currentPage.toString() + ' of ' + pageCount, alignment: 'right',style:'preparedby'  }
              ]
            ]
    },
  layout: 'noBorders', style:'footer'
      }]   
    },
    content: [  
    {  
          text: order.orderProcessing,  
          style: 'following'  
      }, 
    {  
          text: order.orderDescription,  
          style: 'transaction'  
      }, 
    {  
          text: order.quoteDescriptionCusip,  
          style: 'symbolName'  
      }, 
    {  
          text: order.orderPlacedon,  
          style: 'orderplaced'  
      },
      {			columns: this.columnConfiguration(order,origOrder)},

      {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 140, 'auto', '*', '*' ],
          body: this.buildTableBody(
            [{'Principal:':this.splitRegExPlusNum(order.principalAmt)},
            {'Commission:':this.processCalcCommission(order.calculatedCommAmt,entitlements.isBdUser)},
            {'Fees:':this.processCalcFees(order.totalFee,entitlements.isBdUser)},
            {'Total:':this.splitRegExPlusNum(order.netAmt)}
          ],'Estimated Transaction Value')
        },
        layout: 'lightHorizontalLines'
        },
      {
    style: 'tableOrderDetails',
    table: {
      headerRows: 1,
      widths: [ 140, '*', 'auto', '*' ],
      body: this.buildTableBody([
      {'Expiration Date:': [this.editOrderValue(origOrder.expirationDate,order.expirationDate),'']}, 
      {'Strike Price:': [this.editOrderValue(origOrder.strikePrice,order.strikePrice),'']}, 
      {'Contract(s):':[origOrder.ordQty,this.editOrderValue(origOrder.ordQty,order.ordQty)]},
      {'Order Type:':[origOrder.orderType,this.editOrderValue(origOrder.orderType,order.orderType)]},
      {'Stop Price:':[this.editOrigOrderNumber(origOrder.stopPrice),this.editOrderNumber(origOrder.stopPrice,order.stopPrice)]},
      {'Limit Price:':[this.editOrigOrderNumber(origOrder.limitPrice),this.editOrderNumber(origOrder.limitPrice,order.limitPrice)]},
      {'Duration:':[origOrder.duration,this.editOrderValue(origOrder.duration,order.duration)]},
      {'Cust/Firm Ind:': [origOrder.custFirmInd,this.editOrderValue(origOrder.custFirmInd,order.custFirmInd)]}, 

      {'Account Type:':[origOrder.editOrderAccountType,this.editOrderValue(origOrder.editOrderAccountType,order.accountType)]},
      {'Solicited:':[origOrder.solicited,this.editOrderValue(origOrder.solicited,order.solicited)]},
      {'Discretion:':[origOrder.discExercised,this.editOrderNoValue(origOrder.discExercised,order.discExercised)]},
      {'CAT Entity:':[this.origOrderlegalEntity?.shortName,this.editOrderNoValue(this.origOrderlegalEntity?.shortName,this.orderlegalEntity?.shortName)]}
    ],'Order Details',origOrder.orderAction)
    },
    layout: 'lightHorizontalLines'
    },
      {
    style: 'tableOrderDetails',
    table: {
      headerRows: 1,
      widths: [ 140, '*', 'auto', '*' ],
      body: this.buildTableBody([
        {'Order Qualifier:':[origOrder.addlOrdData,this.editOrderNoValue(origOrder.addlOrdData,order.addlOrdData)]},
        {'Memo:':[origOrder.addlIbdMemo.trim(),this.editOrderNoValue(origOrder.addlIbdMemo.trim(),order.addlIbdMemo.trim())]},
        {'Trailers / Comments on Confirm:':[origOrder.trailer.trim(),this.editOrderNoValue(origOrder.trailer.trim(),order.trailer.trim())]},
        {'Source of Input:': [origOrder.sourceOverride,this.editOrderNoValue(origOrder.sourceOverride,order.sourceOverride)]}
      ],'Additional Order Information',origOrder.orderAction)
    },
    layout: 'lightHorizontalLines'
    },
    {
      style: 'tableOrderDetails',
      table: {
        headerRows: 1,
        widths: [ 140, '*', 'auto', '*' ],
        body: this.buildTableBody([
          {'Commission:':[origOrder.commType,this.editOrderNoValue(origOrder.commType,order.commType)]},
          {'Value:':[origOrder.commissionAmt,this.editOrderNoValue(origOrder.commissionAmt,order.commissionAmt)]},
          {'IP1 Override:':[this.editOrigOrderIP(origOrder.splitIP1,origOrder.splitIP1Pct),this.editOrderIP(origOrder.splitIP1,order.splitIP1,origOrder.splitIP1Pct,order.splitIP1Pct)]},
          {'IP2 Override:':[this.editOrigOrderIP(origOrder.splitIP2,origOrder.splitIP2Pct),this.editOrderIP(origOrder.splitIP2,order.splitIP2,origOrder.splitIP2Pct,order.splitIP2Pct)]},
        ],'Commission & IP Override',origOrder.orderAction)
      },
      layout: 'lightHorizontalLines'
      },
      {
    style: 'tableOrderDetails',
    table: {
      headerRows: 1,
      widths: [ 140, '*', 'auto', '*' ],
      body: this.buildTableBody(this.makeOptionEditRegInfoArray(order,origOrder),'Regulatory Information',origOrder.orderAction)
    },
    layout: 'lightHorizontalLines'
    },{
      style: {margin:[0,5,0,0]},
      table: {
        headerRows: 1,
        widths: [ 135, '*', '*', '*' ],
        body: this.taxLotBody
      },
      layout: 'lightHorizontalLines'
    },
    {
      style: {margin:[0,0,0,0]},
      table: {
        headerRows: 0,
        widths: [ 135, '*', '*', '*' ],
        body: this.taxLotGrid
      },
    },

        {  
            text: 'Disclaimer:',  
          style: 'disclaimer',alignment: 'left'  
      },
      {  
          text: disclaimer,  
          style: 'disclaimerText',alignment: 'left'  
      },
      


    ],  
    styles: {  
      footer: {  
          
          margin: [0, 5, 0, 5]  
      }, 
        confirmation: {  
          bold: true,  
          fontSize: 15,  
          margin: [40, 15, 0, 5]  
      }, 
        image: {  
          bold: true,  
          fontSize: 15,  
          margin: [40, 10, 0, 5]  
      }, 
      account: {  
          bold: true,  
          fontSize: 12,  
          margin: [40, 0, 0, 0]  
      }, 
        adress: {  
          margin: [40, 0, 30, 0]  
      }, 
      following: {  
          fontSize: 10,  
          margin: [0, 5, 0, 0]  
      }, 
      transaction: {  
          color: order.orderTitleStyle,
          bold: true,  
          fontSize: 14,  
          margin: [0, 0, 0, 0]  
      },
      symbolName: {  
          bold: true,  
          fontSize: 12,  
          margin: [0, 0, 0, 0]  
      },
      orderplaced: {  
          color: 'gray',
          fontSize: 12,  
          margin: [0, 0, 0, 15]  
      },
      orderplaced2: {  
        fontSize: 10,  
        margin: [0, 0, 0, 15]  
    },
    orderplaced2bold: {  
      bold:true,
      fontSize: 10,  
      margin: [0, 0, 0, 15]  
  },
        tableHeader: {  
          bold: true, 
          color: 'black',
          fontSize: 12,  
          margin: [0, 0, 0, 0]  
      },
      tableHeader2: {  
        bold: true, 
        color: 'black',
        fontSize: 8,  
        margin: [0, 5, 0, 0]  
    },
      tabledata: {  
          bold: true,  
          fontSize: 10,  
          margin: [0, 0, 0, 0]  
      },
      tabledata1: {  
        bold: false,  
        fontSize: 10,  
        margin: [0, 0, 0, 0]  
    },
        tableOrderDetails: {  
          margin: [0, 5, 0, 5]
      },
      disclaimer: {  
          bold: true,  
          fontSize: 10,  
          margin: [0, 0, 30, 0]    
      },
        disclaimerText: {  
          bold: true,  
          fontSize: 10,  
          margin: [0, 0, 0, 0],
      },
      preparedby: {  
          color: 'gray',
          fontSize: 10,  
          margin: [40, 0, 30, 0]  
      },
      sectionHeader: {  
          bold: true,  
          decoration: 'underline',  
          fontSize: 13,  
          margin: [0, 15, 0, 15]  
      } 
    } 
    }
  } else {
    this.logService.log('COMPLEX OPTIONS: professional user, edit order');
    return {
    pageSize: 'Letter',
    pageOrientation: 'portrait',
    pageMargins: [40, 115, 40, 60],
    header: function() {
        return [
  
        {
          columns: [
          {text: order.orderstatus,alignment: 'left', style:'confirmation'},
          {
            image: 'data:image/png;base64,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'
            ,alignment:'right',fit:[100,100],style: 'image'
          }    
          ], 
        }, 
        {
          columns: [
          { text: order.accountName,alignment: 'left', style:'account'},
          ], 
        }, 
        {
          columns: [
        { text: order.accountAdress, alignment: 'left', style:'adress'},
      
        ], 
        },
        {
          canvas: [{ type: 'line', x1: 38, y1: 14, x2: 595-22, y2: 14, lineWidth: 1 }]
        }
      ]
    },

    footer: function(currentPage, pageCount) { 
        return [
    
        {
          canvas: [{ type: 'line', x1: 38, y1: 5, x2: 595-22, y2: 5, lineWidth: 1 }]
        },
        {
          table: {
            headerRows: 1,
            widths: [500, 100],
            body: [
            [{ text: order.preparedBy,alignment: 'left', style:'preparedby' },
              { text: currentPage.toString() + ' of ' + pageCount, alignment: 'right',style:'preparedby'  }
              ]
            ]
    },
  layout: 'noBorders', style:'footer'
      }]   
    },
    content: [  
      
    {  
          text: order.orderProcessing,  
          style: 'following'  
      }, 
    {  
          text: order.orderDescription,  
          style: 'transaction'  
      }, 
    {  
          text: order.quoteDescriptionCusip,  
          style: 'symbolName'  
      }, 
    {  
          text: order.orderPlacedon,  
          style: 'orderplaced'  
      },
      {			columns: this.columnConfiguration(order,origOrder)},
      {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 140, 'auto', '*', '*' ],
          body: this.buildTableBody(
            [{'Order Value:':this.splitRegExPlusNum(Math.abs(order.principalAmt))},
            order.strategy==='Single Order'?{'Commission:':this.processCalcCommission(order.calculatedCommAmt,entitlements.isBdUser)}:{'Commission Leg 1:':this.processCalcCommission(order.calculatedComplexCommAmtEstPrincipal[0],entitlements.isBdUser)},
            order.strategy==='Single Order'?{'':''}:{'Commission Leg 2:':this.processCalcCommission(order.calculatedComplexCommAmtEstPrincipal[1],entitlements.isBdUser)},
            {'Fees:':this.processCalcFees(order.totalFee,entitlements.isBdUser)},
            {'Total:':this.splitRegExPlusNum(Math.abs(order.netAmt))}
          ],'Estimated Transaction Value')
        },
        layout: 'lightHorizontalLines'
        },
        {
          style: 'tableOrderDetails',
          table: {
            body: this.buildComplexGrid(order,origOrder)
          }
        },
      {
    style: 'tableOrderDetails',
    table: {
      headerRows: 1,
      widths: [ 140, '*', 'auto', '*' ],
      body: this.buildTableBody([

      {'Order Type:':[origOrder.orderType,this.editOrderValue(origOrder.orderType,order.orderType)]},
      {'Stop Price:':[this.editOrigOrderNumber(origOrder.stopPrice),this.editOrderNumber(origOrder.stopPrice,order.stopPrice)]},
      {'Limit Price:':[this.editOrigOrderNumber(origOrder.limitPrice),this.editOrderNumber(origOrder.limitPrice,order.limitPrice)]},
      {'Duration:':[origOrder.duration,this.editOrderValue(origOrder.duration,order.duration)]},
      {'Cust/Firm Ind:': [origOrder.custFirmInd,this.editOrderValue(origOrder.custFirmInd,order.custFirmInd)]},

      {'Solicited:':[origOrder.solicited,this.editOrderValue(origOrder.solicited,order.solicited)]},
      {'Discretion:':[origOrder.discExercised,this.editOrderNoValue(origOrder.discExercised,order.discExercised)]},
      {'CAT Entity:':[this.origOrderlegalEntity?.shortName,this.editOrderNoValue(this.origOrderlegalEntity?.shortName,this.orderlegalEntity?.shortName)]}
    ],'Order Details',origOrder.orderAction)
    },
    layout: 'lightHorizontalLines'
    },
      {
    style: 'tableOrderDetails',
    table: {
      headerRows: 1,
      widths: [ 140, '*', 'auto', '*' ],
      body: this.buildTableBody([
        {'Order Qualifier:':[origOrder.addlOrdData,this.editOrderNoValue(origOrder.addlOrdData,order.addlOrdData)]},
        {'Memo:':[origOrder.addlIbdMemo.trim(),this.editOrderNoValue(origOrder.addlIbdMemo.trim(),order.addlIbdMemo.trim())]},
        {'Trailers / Comments on Confirm:':[origOrder.trailer.trim(),this.editOrderNoValue(origOrder.trailer.trim(),order.trailer.trim())]},
        {'Source of Input:': [origOrder.sourceOverride,this.editOrderNoValue(origOrder.sourceOverride,order.sourceOverride)]}
      ],'Additional Order Information',origOrder.orderAction)
    },
    layout: 'lightHorizontalLines'
    },
    {
      style: 'tableOrderDetails',
      table: {
        headerRows: 1,
        widths: [ 140, '*', 'auto', '*' ],
        body: this.buildTableBody([
          order.strategy==='Single Order'?{'Commission:':[origOrder.commType,this.editOrderNoValue(origOrder.commType,order.commType)]}:{'Commission Leg 1:':[origOrder.legCommType[0],this.editOrderNoValue(origOrder.legCommType[0],order.legCommType[0])]},
          order.strategy==='Single Order'?{'Value:':[origOrder.commissionAmt,this.editOrderNoValue(origOrder.commissionAmt,order.commissionAmt)]}:{'Value:':[origOrder.legCommissionAmt[0],this.editOrderNoValue(origOrder.legCommissionAmt[0],order.legCommissionAmt[0])]},
          order.strategy==='Single Order'?{'':''}:{'Commission Leg 2:':[origOrder.legCommType[1],this.editOrderNoValue(origOrder.legCommType[1],order.legCommType[1])]},
          order.strategy==='Single Order'?{'':''}:{'Value:':[origOrder.legCommissionAmt[1],this.editOrderNoValue(origOrder.legCommissionAmt[1],order.legCommissionAmt[1])]},
          {'IP1 Override:':[this.editOrigOrderIP(origOrder.splitIP1,origOrder.splitIP1Pct),this.editOrderIP(origOrder.splitIP1,order.splitIP1,origOrder.splitIP1Pct,order.splitIP1Pct)]},
          {'IP2 Override:':[this.editOrigOrderIP(origOrder.splitIP2,origOrder.splitIP2Pct),this.editOrderIP(origOrder.splitIP2,order.splitIP2,origOrder.splitIP2Pct,order.splitIP2Pct)]},
        ],'Commission & IP Override',origOrder.orderAction)
      },
      layout: 'lightHorizontalLines'
      },
      {
    style: 'tableOrderDetails',
    table: {
      headerRows: 1,
      widths: [ 140, '*', 'auto', '*' ],
      body: this.buildTableBody(this.makeOptionEditRegInfoArray(order,origOrder),'Regulatory Information',origOrder.orderAction)
    },
    layout: 'lightHorizontalLines'
    },{
      style: {margin:[0,5,0,0]},
      table: {
        headerRows: 1,
        widths: [ 135, '*', '*', '*' ],
        body: this.taxLotBody
      },
      layout: 'lightHorizontalLines'
    },
    {
      style: {margin:[0,0,0,0]},
      table: {
        headerRows: 0,
        widths: [ 135, '*', '*', '*' ],
        body: this.taxLotGrid
      },
    },

        {  
            text: 'Disclaimer:',  
          style: 'disclaimer',alignment: 'left'  
      },
      {  
          text: disclaimer,  
          style: 'disclaimerText',alignment: 'left'  
      },
      


    ],  
    styles: {  
      footer: {  
          
          margin: [0, 5, 0, 5]  
      }, 
        confirmation: {  
          bold: true,  
          fontSize: 15,  
          margin: [40, 15, 0, 5]  
      }, 
        image: {  
          bold: true,  
          fontSize: 15,  
          margin: [40, 10, 0, 5]  
      }, 
      account: {  
          bold: true,  
          fontSize: 12,  
          margin: [40, 0, 0, 0]  
      }, 
        adress: {  
          margin: [40, 0, 30, 0]  
      }, 
      following: {  
          fontSize: 10,  
          margin: [0, 5, 0, 0]  
      }, 
      transaction: {  
          color: order.orderTitleStyle,
          bold: true,  
          fontSize: 14,  
          margin: [0, 0, 0, 0]  
      },
      symbolName: {  
          bold: true,  
          fontSize: 12,  
          margin: [0, 0, 0, 0]  
      },
      orderplaced: {  
          color: 'gray',
          fontSize: 12,  
          margin: [0, 0, 0, 15]  
      },
      orderplaced2: {  
        fontSize: 10,  
        margin: [0, 0, 0, 15]  
    },
    orderplaced2bold: {  
      bold:true,
      fontSize: 10,  
      margin: [0, 0, 0, 15]  
  },
        tableHeader: {  
          bold: true, 
          color: 'black',
          fontSize: 12,  
          margin: [0, 0, 0, 0]  
      },
      tableHeader2: {  
        bold: true, 
        color: 'black',
        fontSize: 8,  
        margin: [0, 5, 0, 0]  
    },
      tabledata: {  
          bold: true,  
          fontSize: 10,  
          margin: [0, 0, 0, 0]  
      },
      tabledata1: {  
        bold: false,  
        fontSize: 10,  
        margin: [0, 0, 0, 0]  
    },
        tableOrderDetails: {  
          margin: [0, 5, 0, 5]
      },
      disclaimer: {  
          bold: true,  
          fontSize: 10,  
          margin: [0, 0, 30, 0]    
      },
        disclaimerText: {  
          bold: true,  
          fontSize: 10,  
          margin: [0, 0, 0, 0],
      },
      preparedby: {  
          color: 'gray',
          fontSize: 10,  
          margin: [40, 0, 30, 0]  
      },
      sectionHeader: {  
          bold: true,  
          decoration: 'underline',  
          fontSize: 13,  
          margin: [0, 15, 0, 15]  
      } 
    } 
    }
  }
}

  private editRetailEquityPdf(order:any,entitlements:TradingEntitlements,origOrder:any) {
            this.logService.log('retail user, edit order');

            return {
                pageSize: 'Letter',
                pageOrientation: 'portrait',
                pageMargins: [40, 80, 40, 60],
                header: function() {
                    return [
          
                      {
                        columns: [
                        {text: order.orderstatus,alignment: 'left', style:'confirmation'},
                        {
                          text: ''
                          ,alignment:'right'
                        }    
                        ], 
                      }, 
                    {
                      columns: [
                        { text: order.accountName,alignment: 'left', style:'account'},
                      ], 
                    }, 
                    {
                      columns: [
                        { text: order.accountAdress, alignment: 'left', style:'adress'},
                        
                      ], 
                    },
                    {
                      canvas: [{ type: 'line', x1: 40, y1: 10, x2: 595-22, y2: 10, lineWidth: 1 }]
                    }
                    ]
                },

        footer: function(currentPage, pageCount) { 
          return [
            
          {
            canvas: [{ type: 'line', x1: 38, y1: 5, x2: 595-22, y2: 5, lineWidth: 1 }]
          },
          {
          table: {
              headerRows: 1,
          widths: [500, 100],
          body: [
              [{ text: order.preparedBy,alignment: 'left', style:'preparedby' },
            { text: currentPage.toString() + ' of ' + pageCount, alignment: 'right',style:'preparedby'  }
            ]
          ]
        },
        layout: 'noBorders', style:'footer'
          }]   
        },
        content: [  
          
            
        {  
                text: order.orderProcessing,  
                style: 'following'  
            }, 
        {  
                text: order.orderDescription,  
                style: 'transaction'  
            }, 
        {  
                text: order.quoteDescriptionCusip,  
                style: 'symbolName'  
            }, 
        {  
                text: order.orderPlacedon,  
                style: 'orderplaced'  
            },
            {
              style: 'tableOrderDetails',
              table: {
                headerRows: 1,
                widths: [ 140, '*', '*', '*' ],
                body: [
                  [{border: [false, true, false, false],fillColor: '#eeeeee',text: 'Estimated Transaction Value', style: 'tableHeader', colSpan: 4}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}],
                  ['Principal:', {text: '$'+origOrder.principalAmt, style: 'tabledata'}, '', ''],
                  ['Commission:', {text: '$'+origOrder.calculatedCommAmt, style: 'tabledata'}, '', ''],
                  ['Fees:', {text: '$'+origOrder.totalFee, style: 'tabledata'},'',''],
                  ['Estimated Total Cost:', {text: '$'+origOrder.netAmt, style: 'tabledata'},'',''],
                  ['', '', '', ''],
                ]
              },
              layout: 'lightHorizontalLines'
              },
          {
        style: 'tableOrderDetails',
        table: {
          headerRows: 1,
          widths: [ 140, '*', '*', '*' ],
          body: [
            [{border: [false, true, false, false],fillColor: '#eeeeee',text: 'Order Details', style: 'tableHeader', colSpan: 4}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}, {fillColor: '#eeeeee',text: '', style: 'tableHeader'}],
            ['','Original Value','',origOrder.orderAction==='CHANGE'? 'Changed Value' : 'Corrected Value'],
            ['Transaction:', {text: origOrder.transactionType, style: 'tabledata'},'',{text: this.editOrderValue(origOrder.transactionType,order.transactionType), style: 'tabledata'}],
            ['Symbol:', {text: origOrder.symbol, style: 'tabledata'},'',{text: this.editOrderValue(origOrder.symbol,order.symbol), style: 'tabledata'}],
            ['Quantity:', {text: origOrder.ordQty, style: 'tabledata'}, '', {text: this.editOrderValue(origOrder.ordQty,order.ordQty), style: 'tabledata'}],
            ['Order Type:', {text: origOrder.orderType, style: 'tabledata'}, '',{text: this.editOrderValue(origOrder.orderType,order.orderType), style: 'tabledata'}],
            ['Stop Price:', {text: origOrder.stopPrice, style: 'tabledata'}, '', {text: this.editOrderValue(origOrder.stopPrice,order.stopPrice), style: 'tabledata'}],
            ['Limit Price:', {text: origOrder.limitPrice, style: 'tabledata'}, '',{text: this.editOrderValue(origOrder.limitPrice,order.limitPrice), style: 'tabledata'}],
            this.makeTrailingRow(entitlements,origOrder.trailingBasedOn,order.trailingBasedOn,'Trailing Based On:'),
            this.makeTrailingRow(entitlements,origOrder.trailDollarQty,order.trailDollarQty,'Trailing Dollar Amount:'),
            this.makeTrailingRow(entitlements,origOrder.trailPctQty,order.trailPctQty,'Trailing Percent Amount:'),
            this.makeTrailingRow(entitlements,origOrder.limitOffset ,order.limitOffset ,'Limit Offset:'),
            ['Duration:', {text: origOrder.duration, style: 'tabledata'},'',{text: this.editOrderValue(origOrder.duration,order.duration), style: 'tabledata'}],
            ['Account Type:', {text: origOrder.editOrderAccountType, style: 'tabledata'},'',{text:this.editOrderValue(origOrder.editOrderAccountType,order.accountType), style: 'tabledata'}],
            ['','','','']
          ]
        },
        layout: 'lightHorizontalLines'
        },
            {  
                text: 'Disclaimer:',  
              style: 'disclaimer',alignment: 'left'  
          },
          {  
              text: disclaimer,  
              style: 'disclaimerText',alignment: 'left'  
          },
          


        ],  
        styles: {  
          footer: {  
              
              margin: [0, 5, 0, 5]  
          }, 
            confirmation: {  
              bold: true,  
              fontSize: 15,  
              margin: [40, 15, 0, 5]  
          }, 
            image: {  
              bold: true,  
              fontSize: 15,  
              margin: [40, 10, 0, 5]  
          }, 
          account: {  
              bold: true,  
              fontSize: 12,  
              margin: [40, 0, 0, 0]  
          }, 
            adress: {  
              margin: [40, 0, 30, 0]  
          }, 
          following: {  
              fontSize: 10,  
              margin: [0, 5, 0, 0]  
          }, 
          transaction: {  
              color: order.orderTitleStyle,
              bold: true,  
              fontSize: 14,  
              margin: [0, 0, 0, 0]  
          },
          symbolName: {  
              bold: true,  
              fontSize: 12,  
              margin: [0, 0, 0, 0]  
          },
          orderplaced: {  
              color: 'gray',
              fontSize: 12,  
              margin: [0, 0, 0, 15]  
          },
            tableHeader: {  
              bold: true, 
              color: 'black',
              fontSize: 12,  
              margin: [0, 0, 0, 0]  
          },
          tabledata: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 0, 0]  
          },
          tabledata1: {  
            bold: false,  
            fontSize: 10,  
            margin: [0, 0, 0, 0]  
        },
            tableOrderDetails: {  
              margin: [0, 5, 0, 5]
          },
          disclaimer: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 30, 0]    
          },
            disclaimerText: {  
              bold: true,  
              fontSize: 10,  
              margin: [0, 0, 0, 0],
          },
          preparedby: {  
              color: 'gray',
              fontSize: 10,  
              margin: [40, 0, 30, 0]  
          },
          sectionHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 13,  
              margin: [0, 15, 0, 15]  
          } 
        }
        }
  }

private getDocumentDefinitionForEditOrder(order: any,entitlements:TradingEntitlements,origOrder:any) {
  if (entitlements.isProfessionalUser) {
    switch(order.tradeType) {
      case 'EQUITY': return this.editProEquityPdf(order,origOrder,entitlements);
      case 'OPTION': return this.editProOptionsPdf(order,origOrder,entitlements);
      default: return {};
    }
    } 
  else {
    switch(order.tradeType) {
      case 'EQUITY': return this.editRetailEquityPdf(order,entitlements,origOrder);
      default: return {};
    }
  }
}

private makeTrailingRow(entitlements:TradingEntitlements,orderVal:any,origOrderVal:any,text:string) {
  if (entitlements.isTrailingStopEnabled) {
    let editedVal = '';
    if (origOrderVal !== orderVal) {
      editedVal = orderVal
    }
    return [text, {text: origOrderVal, style: 'tabledata'}, '', {text: editedVal, style: 'tabledata'}]
  } else {
    return ['','','',''];
  }
}

private getPrintOrder(packet:PdfPacket):any{
    let printOrder:any;
    let pdf = JSON.parse(JSON.stringify(packet));
    let username:string = pdf.username;
    let order:any = pdf.order;
    let entitlements:TradingEntitlements = pdf.entitlements;
    let account:Account = pdf.account;
    let _orderProcessing:string = '';
    let _orderstatus: string = pdf._orderstatus;
    let _accountName: string = pdf._accountName;
    let _acctAddress: string = pdf._acctAddress;
    let _orderTitleStyleColor: string = pdf._orderTitleStyleColor;
    let _orderPlacedon: string = pdf._orderPlacedon;
    let origOrder: any = pdf.origOrder;
    switch(order.tradeType) {
      case('EQUITY'): {
        printOrder = {
          orderProcessing:_orderProcessing,
          orderstatus: _orderstatus,
          accountName: _accountName,
          refNum:this.equityTradingUtils.processRefNum(order,entitlements),
          status: this.equityTradingUtils.processStatus(order.status),
          formattedOrderPlacedDateTime: getValueOrEmptyString(order.formattedOrderPlacedDateTime),
          tradeType:getValueOrEmptyString(order.tradeType),
          orderAction:getValueOrEmptyString(order.orderAction),
          accountAdress: getValueOrEmptyString(_acctAddress).replace(/\s\s+/g, ' '),
          orderDescription: getValueOrEmptyString(this.equityTradingUtils.getOrderDescription(order, entitlements)),
          orderTitleStyle: _orderTitleStyleColor,
          quoteDescription: getValueOrEmptyString(this.equityTradingUtils.getQuoteDescription(order)),
          quoteDescriptionCusip: getValueOrEmptyString(this.equityTradingUtils.getQuoteDescriptionCusip(order)),
          orderPlacedon: _orderPlacedon,
          transactionType: this.equityTradingUtils.getTransactionType(order.transactionType),
          symbol: order.quote.symId,
          ordQty: this.equityTradingUtils.getQuantity(order),
          orderType: getValueOrEmptyString(this.equityTradingUtils.getOrderType(order.orderType)),
          stopPrice: getValueOrEmptyString(order.stopPrice),
          limitPrice: getValueOrEmptyString(order.limitPrice),
          trailDollarQty: getValueOrEmptyString(order.trailDollarQty),
          trailPctQty: getValueOrEmptyString(order.trailPctQty),
          limitOffset: getValueOrEmptyString(order.limitOffset),
          trailingBasedOn: this.getTrailingBasedOn(order.trailingBasedOn),
          settlementCcy: getValueOrEmptyString(order.settlementCcy),
          docLocation: getValueOrEmptyString(order.docLocation?.trim()),
          chgPct: getValueOrEmptyString(order.chgPct),
          duration: getValueOrEmptyString(this.equityTradingUtils.processDuration(order.duration,getValueOrEmptyString(order.gtdDate))),
          accountType: this.equityTradingUtils.getAccountType(order),
          editOrderAccountType: this.editOrderAcctType(order,origOrder,account),
          solicited: this.equityTradingUtils.getSolicited(order.solicited, entitlements, account),
          trailer: getValueOrEmptyString(order.trailer),
          discExercised: this.equityTradingUtils.getDiscExercised(order.discExercised, entitlements), 
          catEntity: getValueOrEmptyString(order.fdid),
          //equity-order-review-additional-info-component
          addlOrdData: this.equityTradingUtils.getAddlOrdData(order.addlOrdData),
          floorInst: this.equityTradingUtils.getFloorInst(order.floorInst),
          paInd: this.equityTradingUtils.getPaInd(order,entitlements,account),
          addlIbdMemo: this.riaFilter(getValueOrEmptyString(order.addlIbdMemo),entitlements),
          formattedTrailer: this.equityTradingUtils.getFormattedTrailer(order, entitlements),
          sourceOverride: this.riaFilter(this.equityTradingUtils.getSourceOfInput(order.sourceOverride),entitlements),
    
          ///estimated principal
          principalAmt: this.getPrincipalAmt(order),
          commType:this.getCommType(order),
          commissionAmt: this.getCommissionAmt(order),
          calculatedCommAmt: this.processValueOrNull(order.commission?.calculatedCommAmt,entitlements),
          totalFee: this.processValueOrNull(order.commission?.totalFee,entitlements),
          netAmt: this.getValueOrZero(order.commission?.netAmt),
    
          //commission IP 
          splitIP1: getValueOrEmptyString(order.commission?.splitIP1),
          splitIP1Pct: this.getPctOrEmptyString(order.commission?.splitIP1Pct),
          splitIP2: getValueOrEmptyString(order.commission?.splitIP2),
          splitIP2Pct: this.getPctOrEmptyString(order.commission?.splitIP2Pct),
          groupId: getValueOrEmptyString(order.commission?.groupId),
    
          //regulatory information 
          secIbdOrdRcvDate: this.riaFilter(getValueOrEmptyString(this.equityTradingUtils.formatBackendDate(order.secIbdOrdRcvDate,origOrder)) + ' ' + getValueOrEmptyString(this.equityTradingUtils.formatBackendTime(order.secIbdOrdRcvTime)) + ' ' + getValueOrEmptyString(order.secIbdOrdRcvTimeZone),entitlements),
          secIbdOrdRcvFromName: this.riaFilter(getValueOrEmptyString(order.secIbdOrdRcvFromName),entitlements),
          secTermsAndConditions: this.riaFilter(getValueOrEmptyString(order.secTermsAndConditions),entitlements),
          oatsDeskReceiptDate1: this.riaFilter(getValueOrEmptyString(this.equityTradingUtils.formatBackendDate(order.oatsDeskReceiptDate1,origOrder)) + ' ' + getValueOrEmptyString(this.equityTradingUtils.formatBackendTime(order.oatsDeskReceiptTime1)) + ' ' + getValueOrEmptyString(order.oatsDeskReceiptZone1),entitlements),
          oatsDeskTypeCode1: this.riaFilter(this.equityTradingUtils.getDeskRoute(order.oatsDeskTypeCode1),entitlements),
          ordXctnTxt1: this.riaFilter(getValueOrEmptyString(order.ordXctnTxt1),entitlements),
          oatsDeskReceiptDate2: this.riaFilter(getValueOrEmptyString(this.equityTradingUtils.formatBackendDate(order.oatsDeskReceiptDate2,origOrder)) + ' ' + getValueOrEmptyString(this.equityTradingUtils.formatBackendTime(order.oatsDeskReceiptTime2)) + ' ' + getValueOrEmptyString(order.oatsDeskReceiptZone2),entitlements),
          oatsDeskTypeCode2: this.riaFilter(this.equityTradingUtils.getDeskRoute(order.oatsDeskTypeCode2),entitlements),
          ordXctnTxt2: this.riaFilter(getValueOrEmptyString(order.ordXctnTxt2),entitlements),
          preparedBy: this.equityTradingUtils.getPreparedBy(username)
        }
      } 
      break;
      case('MUTUAL_FUND'):
      case('PLAN_529FUND'): {
        printOrder = {
          orderProcessing:_orderProcessing,
          orderstatus: _orderstatus,
          accountName: _accountName,
          formattedOrderPlacedDateTime: getValueOrEmptyString(order.formattedOrderPlacedDateTime),
          tradeType:getValueOrEmptyString(order.tradeType),
          orderAction:getValueOrEmptyString(order.orderAction),
          accountAdress: getValueOrEmptyString(_acctAddress).replace(/\s\s+/g, ' '),
          orderDescription: getValueOrEmptyString(this.mutualFundTradingUtils.getOrderDescription(order,this.currencyCode,this.isNonDollar)),
          orderTitleStyle: _orderTitleStyleColor,
          quoteDescription: this.mutualFundTradingUtils.buyRedeem.includes(this.mutualFundTradingUtils.getTransactionType(order.transactionType))?getValueOrEmptyString(this.mutualFundTradingUtils.getQuoteDescription(order)):getValueOrEmptyString(this.mutualFundTradingUtils.getQuoteDescription(order) + '\n' + this.mutualFundTradingUtils.getQuoteDescriptionForNonBuyRedeem(order)),
          quoteDescriptionCusip: this.mutualFundTradingUtils.buyRedeem.includes(this.mutualFundTradingUtils.getTransactionType(order.transactionType))?getValueOrEmptyString(this.mutualFundTradingUtils.getQuoteDescriptionCusip(order)):getValueOrEmptyString(this.mutualFundTradingUtils.getQuoteDescriptionCusip(order) + '\n' + this.mutualFundTradingUtils.getQuoteDescriptionCusipForNonBuyRedeem(order)),
          orderPlacedon: _orderPlacedon,
          transactionType: this.mutualFundTradingUtils.getTransactionType(order.transactionType),
          symbol1: order.quote.symId,
          symbol2:this.mutualFundTradingUtils.buyRedeem.includes(this.mutualFundTradingUtils.getTransactionType(order.transactionType))?'':getValueOrEmptyString(order.exchangeMutualFund.symbol),
          ordQty:this.mutualFundTradingUtils.getQuantity(order),
          orderType: getValueOrEmptyString(this.equityTradingUtils.getOrderType(order.orderType)),
          stopPrice: getValueOrEmptyString(order.stopPrice),
          limitPrice: getValueOrEmptyString(order.limitPrice),
          trailDollarQty: getValueOrEmptyString(order.trailDollarQty),
          trailPctQty: getValueOrEmptyString(order.trailPctQty),
          limitOffset: getValueOrEmptyString(order.limitOffset),
          trailingBasedOn: this.getTrailingBasedOn(order.trailingBasedOn), 
          settlementCcy: getValueOrEmptyString(order.settlementCcy),
          docLocation: getValueOrEmptyString(order.docLocation),
          chgPct: getValueOrEmptyString(order.chgPct),
          duration: getValueOrEmptyString(this.equityTradingUtils.processDuration(order.duration,getValueOrEmptyString(order.gtdDate))),
          accountType: this.mutualFundTradingUtils.getAccountType(order,this.isMultiPositionRedeemOrExchange),
          solicited: this.mutualFundTradingUtils.getSolicited(order, entitlements),
          trailer: getValueOrEmptyString(order.trailer),
          discExercised: this.mutualFundTradingUtils.getDiscExercised(order), 
          catEntity: getValueOrEmptyString(order.fdid),
          eligibleToBuyAtNav: this.mutualFundTradingUtils.getEligibleToBuyAtNav(order,entitlements),
          buyAtNav:this.mutualFundTradingUtils.getBuyAtNav(order.buyAtNav),
          loadNoLoadInd:getValueOrEmptyString(order.mutualFund.loadNoLoadInd),
          loiRoaIndicator:getValueOrEmptyString(order.loiRoaIndicator),
          loiValue:this.mutualFundTradingUtils.getLoiValue(order,entitlements),
          loiDate: this.mutualFundTradingUtils.getLoiDate(order,entitlements),
          roaValue:this.mutualFundTradingUtils.getRoaValue(order,entitlements),
          dvre:this.mutualFundTradingUtils.getDvre(order),
          shareClassReviewed:this.mutualFundTradingUtils.getShareClassReviewed(order,entitlements),
          balanceType: this.mutualFundTradingUtils.getBalanceType(order),
          fundCutoffTime: this.mutualFundTradingUtils.getFundCutoffTime(order),
          fundVestDerivedVal: this.mutualFundTradingUtils.getFundVestDerivedVal(order),
          redemptionFeeWaiver: this.mutualFundTradingUtils.getRedemptionFeeWaiver(order,entitlements),
          shortSettle: this.mutualFundTradingUtils.getShortSettle(order,entitlements),
          contributionType:this.mutualFundTradingUtils.getContributionType(order,account),
          originalContribution:this.mutualFundTradingUtils.getOriginalContribution(order,account),
          earningsType:this.mutualFundTradingUtils.getEarningsType(order,account),
          earningsAmount:this.mutualFundTradingUtils.getEarningsAmount(order,account),
          distributionType:this.mutualFundTradingUtils.getDistributionType(order,account),
          payToType:this.mutualFundTradingUtils.getPayToType(order,account),
          //equity-order-review-additional-info-component
          addlOrdData: this.equityTradingUtils.getAddlOrdData(order.addlOrdData),
          floorInst: this.equityTradingUtils.getFloorInst(order.floorInst),
          overUnderIndicator: this.mutualFundTradingUtils.getOverUnderIndicator(order,entitlements),
          deliver:this.mutualFundTradingUtils.getDeliver(order,entitlements),
          fundAccountNum: this.mutualFundTradingUtils.getFundAccountNum(order,entitlements),
          grossNetIndicator: this.mutualFundTradingUtils.getGrossNetIndicator(order,entitlements),
          cdscWaiver:this.mutualFundTradingUtils.getCdscWaiver(order,entitlements),
          sourceOfFunds:this.mutualFundTradingUtils.getSourceOfFunds(order,entitlements),
          //paInd: this.equityTradingUtils.getPaInd(order.paInd),
          addlIbdMemo: this.riaFilter(getValueOrEmptyString(order.addlIbdMemo),entitlements),
          formattedTrailer: this.equityTradingUtils.getFormattedTrailer(order, entitlements),
          sourceOverride: this.riaFilter(this.mutualFundTradingUtils.getSourceOfInput(order,entitlements),entitlements),
          attestation: this.mutualFundTradingUtils.getMfInvestObjCode(order),
          asOfDate:getValueOrEmptyString(order.valueDate),
          errAcctNum:getValueOrEmptyString(order.zipCd),
          ///estimated principal
          principalAmt: this.getPrincipalAmt(order),
          commType:this.getCommType(order),
          commissionAmt: this.getCommissionAmt(order),
          calculatedCommAmt: this.processCalcCommMutualFund(order.commission?.calculatedCommAmt,entitlements),
          totalFee: this.processFeesMutualFund(order.commission?.totalFee,entitlements),
          netAmt: this.getValueOrZero(order.commission?.netAmt),
    
          //commission IP 
          splitIP1: getValueOrEmptyString(order.commission?.splitIP1),
          splitIP1Pct: this.getPctOrEmptyString(order.commission?.splitIP1Pct),
          splitIP2: getValueOrEmptyString(order.commission?.splitIP2),
          splitIP2Pct: this.getPctOrEmptyString(order.commission?.splitIP2Pct),
          groupId: getValueOrEmptyString(order.commission?.groupId),
    
          //regulatory information 
          secIbdOrdRcvDate: this.riaFilter(getValueOrEmptyString(this.equityTradingUtils.formatBackendDate(order.secIbdOrdRcvDate,origOrder)) + ' ' + getValueOrEmptyString(this.equityTradingUtils.formatBackendTime(order.secIbdOrdRcvTime)) + ' ' + getValueOrEmptyString(order.secIbdOrdRcvTimeZone),entitlements),
          secIbdOrdRcvFromName: this.riaFilter(getValueOrEmptyString(order.secIbdOrdRcvFromName),entitlements),
          secTermsAndConditions: this.riaFilter(getValueOrEmptyString(order.secTermsAndConditions),entitlements),
          preparedBy: this.equityTradingUtils.getPreparedBy(username)
        }
      } 
      break;
      case('OPTION'): {
        printOrder = (!entitlements.isEntitledToComplexOption || !this.optionTradingUtils.optionLegSymbol?.length)?{
          orderProcessing:_orderProcessing,
          orderstatus: _orderstatus,
          accountName: _accountName,
          refNum:this.equityTradingUtils.processRefNum(order,entitlements),
          status: this.equityTradingUtils.processStatus(order.status),
          formattedOrderPlacedDateTime: getValueOrEmptyString(order.formattedOrderPlacedDateTime),
          tradeType:getValueOrEmptyString(order.tradeType),
          orderAction:getValueOrEmptyString(order.orderAction),
          accountAdress: getValueOrEmptyString(_acctAddress).replace(/\s\s+/g, ' '),
          orderDescription: getValueOrEmptyString(this.optionTradingUtils.getOrderDescription(order,entitlements)),
          orderTitleStyle: _orderTitleStyleColor,
          quoteDescription: getValueOrEmptyString(this.optionTradingUtils.getQuoteDescription(order)),
          quoteDescriptionCusip: getValueOrEmptyString(this.optionTradingUtils.getQuoteDescriptionCusip(order)),
          orderPlacedon: _orderPlacedon,
          transactionType: this.optionTradingUtils.getTransactionType(order.transactionType),
          symbol: order.quote.symId,
          ordQty: this.optionTradingUtils.getQuantity(order),
          orderType: getValueOrEmptyString(this.optionTradingUtils.getOrderType(order.orderType)),
          stopPrice: getValueOrEmptyString(order.stopPrice),
          limitPrice: getValueOrEmptyString(order.limitPrice),
          trailDollarQty: getValueOrEmptyString(order.trailDollarQty),
          trailPctQty: getValueOrEmptyString(order.trailPctQty),
          limitOffset: getValueOrEmptyString(order.limitOffset),
          trailingBasedOn: this.getTrailingBasedOn(order.trailingBasedOn),
          settlementCcy: getValueOrEmptyString(order.settlementCcy),
          docLocation: getValueOrEmptyString(order.docLocation),
          chgPct: getValueOrEmptyString(order.chgPct),
          duration: getValueOrEmptyString(this.optionTradingUtils.processDuration(order.duration,getValueOrEmptyString(order.gtdDate))),
          accountType: this.optionTradingUtils.getAccountType(order),
          editOrderAccountType: this.editOrderAcctType(order,origOrder,account),
          solicited: this.optionTradingUtils.getSolicited(order.solicited, entitlements, account),
          trailer: getValueOrEmptyString(this.optionTradingUtils.setFormattedTrailer(order)),
          discExercised: this.optionTradingUtils.getDiscExercised(order.discExercised, entitlements), //maybe remove the first parameter
          catEntity: getValueOrEmptyString(order.fdid),
          expirationDate: this.optionTradingUtils.getExpiryDate(order),
          strikePrice: this.splitRegExPlusNum(+order.quote?.strikePrice),
          custFirmInd:this.optionTradingUtils.getCustFirmInd(order,entitlements,account),
          //equity-order-review-additional-info-component
          addlOrdData: this.equityTradingUtils.getAddlOrdData(order.addlOrdData),
          addlIbdMemo: this.riaFilter(getValueOrEmptyString(order.addlIbdMemo),entitlements),
          formattedTrailer: this.equityTradingUtils.getFormattedTrailer(order, entitlements),
          sourceOverride: this.riaFilter(this.equityTradingUtils.getSourceOfInput(order.sourceOverride),entitlements),
    
          ///estimated principal
          principalAmt: this.getPrincipalAmt(order),
          commType:this.getCommType(order),
          commissionAmt: this.getCommissionAmt(order),
          calculatedCommAmt: this.processValueOrNull(order.commission?.calculatedCommAmt,entitlements),
          totalFee: this.processValueOrNull(order.commission?.totalFee,entitlements),
          netAmt: this.getValueOrZero(order.commission?.netAmt),
    
          //commission IP 
          splitIP1: getValueOrEmptyString(order.commission?.splitIP1),
          splitIP1Pct: this.getPctOrEmptyString(order.commission?.splitIP1Pct),
          splitIP2: getValueOrEmptyString(order.commission?.splitIP2),
          splitIP2Pct: this.getPctOrEmptyString(order.commission?.splitIP2Pct),
          groupId: getValueOrEmptyString(order.commission?.groupId),
    
          //regulatory information 
          secIbdOrdRcvDate: this.riaFilter(getValueOrEmptyString(this.equityTradingUtils.formatBackendDate(order.secIbdOrdRcvDate,origOrder)) + ' ' + getValueOrEmptyString(this.equityTradingUtils.formatBackendTime(order.secIbdOrdRcvTime)) + ' ' + getValueOrEmptyString(order.secIbdOrdRcvTimeZone),entitlements),
          secIbdOrdRcvFromName: this.riaFilter(getValueOrEmptyString(order.secIbdOrdRcvFromName),entitlements),
          secTermsAndConditions: this.riaFilter(getValueOrEmptyString(order.secTermsAndConditions),entitlements),
          preparedBy: this.equityTradingUtils.getPreparedBy(username)
        }: {
          orderProcessing:_orderProcessing,
          orderstatus: _orderstatus,
          accountName: _accountName,
          refNum:this.equityTradingUtils.processRefNum(order,entitlements),
          status: this.equityTradingUtils.processStatus(order.status),
          rawStatus: getValueOrEmptyString(order.status?.trim()),
          formattedOrderPlacedDateTime: getValueOrEmptyString(order.formattedOrderPlacedDateTime),
          tradeType:getValueOrEmptyString(order.tradeType),
          orderAction:getValueOrEmptyString(order.orderAction),
          strategy:this.optionTradingUtils.getStrategy(order),
          ordDtlKey:!!origOrder?.ordDtlKey,
          accountAdress: getValueOrEmptyString(_acctAddress).replace(/\s\s+/g, ' '),
          orderDescription: getValueOrEmptyString(this.optionTradingUtils.getOrderDescription(order,entitlements)),
          orderTitleStyle: _orderTitleStyleColor,
          quoteDescriptionCusip: getValueOrEmptyString(this.optionTradingUtils.createComplexDescriptionCusip(order)),
          orderPlacedon: _orderPlacedon,
          transactionType: this.optionTradingUtils.optionLegTransactionTypes,
          symbol:  this.optionTradingUtils.optionLegSymbol,
          ordQty: this.optionTradingUtils.optionLegQty,
          editOrdQty: this.optionTradingUtils.origOptionLegQty,
          orderType: getValueOrEmptyString(this.optionTradingUtils.getOrderType(order.orderType)),
          stopPrice: getValueOrEmptyString(order.stopPrice),
          limitPrice: getValueOrEmptyString(order.limitPrice),
          trailDollarQty: getValueOrEmptyString(order.trailDollarQty),
          trailPctQty: getValueOrEmptyString(order.trailPctQty),
          limitOffset: getValueOrEmptyString(order.limitOffset),
          trailingBasedOn: this.getTrailingBasedOn(order.trailingBasedOn),
          settlementCcy: getValueOrEmptyString(order.settlementCcy),
          docLocation: getValueOrEmptyString(order.docLocation),
          chgPct: getValueOrEmptyString(order.chgPct),
          duration: getValueOrEmptyString(this.optionTradingUtils.processDuration(order.duration,getValueOrEmptyString(order.gtdDate))),
          accountType: this.optionTradingUtils.optionLegAccountTypes,
          editOrderAccountType: this.editOrderAcctType(order,origOrder,account),
          solicited: this.optionTradingUtils.getSolicited(order.solicited, entitlements, account),
          trailer: getValueOrEmptyString(this.optionTradingUtils.setFormattedTrailer(order)),
          discExercised: this.optionTradingUtils.getDiscExercised(order.discExercised, entitlements), //maybe remove the first parameter
          catEntity: getValueOrEmptyString(order.fdid),
          expirationDate: order.quote.optExpnDt?.split(' ')[0],
          strikePrice: this.splitRegExPlusNum(order.quote.optStrikePrc),
          custFirmInd:this.optionTradingUtils.getCustFirmInd(order,entitlements,account),
          //strLvsQty:this.optionTradingUtils.optionLegStrLvsQty,
          //equity-order-review-additional-info-component
          addlOrdData: this.equityTradingUtils.getAddlOrdData(order.addlOrdData),
          addlIbdMemo: this.riaFilter(getValueOrEmptyString(order.addlIbdMemo),entitlements),
          formattedTrailer: this.equityTradingUtils.getFormattedTrailer(order, entitlements),
          sourceOverride: this.riaFilter(this.equityTradingUtils.getSourceOfInput(order.sourceOverride),entitlements),
    
          ///estimated principal
          principalAmt: this.getPrincipalAmt(order),
          commType:this.getCommType(order),
          legCommType:this.getComplexCommType(order),
          commissionAmt: this.getCommissionAmt(order),
          legCommissionAmt: this.getComplexCommissionAmt(order),
          calculatedCommAmt: this.processValueOrNull(order.commission?.calculatedCommAmt,entitlements),
          calculatedComplexCommAmt: this.getComplexCalculatedCommAmt(order),
          calculatedComplexCommAmtEstPrincipal: this.getComplexCommAmtForEstPrincipal(order,entitlements),
          totalFee: this.processValueOrNull(order.commission?.totalFee,entitlements),
          netAmt: this.getValueOrZero(order.commission?.netAmt),
    
          //commission IP 
          splitIP1: getValueOrEmptyString(order.commission?.splitIP1),
          splitIP1Pct: this.getPctOrEmptyString(order.commission?.splitIP1Pct),
          splitIP2: getValueOrEmptyString(order.commission?.splitIP2),
          splitIP2Pct: this.getPctOrEmptyString(order.commission?.splitIP2Pct),
          groupId: getValueOrEmptyString(order.commission?.groupId),
    
          //regulatory information 
          secIbdOrdRcvDate: this.riaFilter(getValueOrEmptyString(this.equityTradingUtils.formatBackendDate(order.secIbdOrdRcvDate,origOrder)) + ' ' + getValueOrEmptyString(this.equityTradingUtils.formatBackendTime(order.secIbdOrdRcvTime)) + ' ' + getValueOrEmptyString(order.secIbdOrdRcvTimeZone),entitlements),
          secIbdOrdRcvFromName: this.riaFilter(getValueOrEmptyString(order.secIbdOrdRcvFromName),entitlements),
          secTermsAndConditions: this.riaFilter(getValueOrEmptyString(order.secTermsAndConditions),entitlements),
          preparedBy: this.equityTradingUtils.getPreparedBy(username)
        }
      }
      break;
      default: printOrder = {};
    }
  this.logService.info('*********Order PDF: ', printOrder);
  return printOrder;
}

private riaFilter(str:string,entitlements:TradingEntitlements) {
  if (!entitlements.isBdUser) {
    return ''
  } else {
    return str;
  }
}

private editOrderAcctType(order:any,origOrder:any,account:Account):string {
  return !!origOrder?.ordDtlKey ? this.equityTradingUtils.getAccountTypeEditOrder(account,order):'';
}

private getTrailingBasedOn(trailingBasedOn:string) {
    //FIXME -- pull out to common library.
  if (trailingBasedOn==='A') {
    return 'Last Quote';
  } else if (trailingBasedOn==='B') {
    return 'Last Trade'
  } else {
    return ''
  }
}

private getPrincipalAmt(order:any) {
  //FIXME -- pull out to common library.
  if (!!order.commission?.principalAmt && order.commission?.principalAmt !== 0) {
    return order.commission.principalAmt;
  } else {
    return 0.00;
  }
}

private getCommType(order:any) {
  //FIXME -- pull out to common library.
  if (!!order.commission?.commType) {
    return this.equityTradingUtils.getCommType(order.commission.commType);
  } else {
    return '';
  }
}

private getCommissionAmt(order:any) {
  //FIXME -- pull out to common library.
  if (order.commission?.commissionAmt === null) {
    return '';
  } else if (!!order.commission?.commissionAmt) {
    return this.equityTradingUtils.processCommissionAmt(order.commission.commType,order.commission.commissionAmt);
  } else {
    return 0;
  }
}

private getComplexCommType(order:any) {
  //FIXME -- pull out to common library.
  let optionLegCommType: any[] = [];
  for ( let i: number = 0; i < this.optionTradingUtils.optionLegSymbol.length; i++ ) {
    if (!!order.optionLegList[i]?.commission?.commType) {
      optionLegCommType.push(this.optionTradingUtils.getCommType(order.optionLegList[i].commission.commType));
    } else {
      optionLegCommType.push('');
    }
  }
  return optionLegCommType;
}

private getComplexCommissionAmt(order:any) {
  //FIXME -- pull out to common library.
  let optionLegCommissionAmt:any[] = [];
  for ( let i: number = 0; i < this.optionTradingUtils.optionLegSymbol.length; i++ ) {
    if (order.optionLegList[i]?.commission?.commissionAmt === null) {
      optionLegCommissionAmt.push('');
    } else if (!!order.optionLegList[i]?.commission?.commissionAmt) {
      optionLegCommissionAmt.push(this.optionTradingUtils.processCommissionAmt(order.optionLegList[i].commission.commType,order.optionLegList[i].commission.commissionAmt));
    } else {
      optionLegCommissionAmt.push(0);
    }
  }
  return optionLegCommissionAmt;
}

private getComplexCalculatedCommAmt(order:any) {
  let optionLegCalcCommissionAmt:any[] = [];
  for ( let i: number = 0; i < this.optionTradingUtils.optionLegSymbol.length; i++ ) { 
    if (!!order.optionLegList[i]?.commission?.commissionAmt) { 
      optionLegCalcCommissionAmt.push(this.getValueOrZero(order.optionLegList[i].commission.commissionAmt))
    } else {
      optionLegCalcCommissionAmt.push(0)
    }
  }
  return optionLegCalcCommissionAmt
}

private getValueOrZero(value:any) {
  //FIXME -- pull out to common library.
  if (!!value) {
    return value;
  } else {
    return 0;
  }
}

private processValueOrNull(value:any,entitlements:TradingEntitlements) {
  //FIXME -- pull out to common library.
  if (((value===null) || !entitlements.isBdUser) || this.isNonDollar) {
    return '';
  } else if (!!value) {
    return value;
  } else {
    return 0;
  }
}

private processCalcCommMutualFund(value:number,entitlements:TradingEntitlements) {
  let commAmt = !!value ? value : 0.00;
  if (!entitlements.isBdUser) {
    return '';
  } else {
    return commAmt;
  }
}

private processFeesMutualFund(value:number,entitlements:TradingEntitlements) {
  let totalFee = value !== null && value !== 0 ? value : 0.00;
  if (!entitlements.isBdUser) {
    return '';
  } else {
    return totalFee;
  }
}

private getPctOrEmptyString(value: any) {
  //FIXME -- pull out to common library.
  if (!!value) {
    return value+'%'
  } else {
    return ''
  }
}

private getComplexCommAmtForEstPrincipal(order:any,entitlements:TradingEntitlements) {
  let optionLegCalcCommission:any[] = [];
  for ( let i: number = 0; i < this.optionTradingUtils.optionLegSymbol.length; i++ ) { 
    if (!entitlements.isBdUser || (order.optionLegList[i]?.commission?.calculatedCommAmt===null) || this.isNonDollar) {
      optionLegCalcCommission.push('')
    } else if (!!order.optionLegList[i]?.commission?.calculatedCommAmt) { 
      optionLegCalcCommission.push(this.getValueOrZero(order.optionLegList[i].commission.calculatedCommAmt))
    } else {
      optionLegCalcCommission.push(0.00)
    }
  }
  return optionLegCalcCommission
}


}
